/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function ajvEqual(a, b) {
    if (a === b)
        return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor)
            return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length)
                return false;
            for (i = length; i-- !== 0;)
                if (!ajvEqual(a[i], b[i]))
                    return false;
            return true;
        }
        if (a.constructor === RegExp)
            return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf)
            return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString)
            return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length)
            return false;
        for (i = length; i-- !== 0;)
            if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
                return false;
        for (i = length; i-- !== 0;) {
            var key = keys[i];
            if (!ajvEqual(a[key], b[key]))
                return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const articleDataSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-solution-domain:ArticleData',
    type: 'object',
    properties: {
        title: { type: 'string', minLength: 1 },
        type: { type: 'string', enum: ['growth', 'efficiency', 'attainment'] },
        industry: { type: 'string', minLength: 1 },
        link: { type: 'string', minLength: 1 },
        linkType: { type: 'string', enum: ['article', 'survey', 'video', 'whitepaper'] },
        description: { type: 'string', minLength: 1 }
    }
};
const func2 = ucs2length;
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:ArticleData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.title !== undefined) {
                let data0 = data.title;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/title',
                                    schemaPath: '#/properties/title/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/title',
                                schemaPath: '#/properties/title/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.type !== undefined) {
                    let data1 = data.type;
                    const _errs3 = errors;
                    if (typeof data1 !== 'string') {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'growth' || data1 === 'efficiency' || data1 === 'attainment')) {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema29.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.industry !== undefined) {
                        let data2 = data.industry;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/industry',
                                            schemaPath: '#/properties/industry/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/industry',
                                        schemaPath: '#/properties/industry/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.link !== undefined) {
                            let data3 = data.link;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/link',
                                                schemaPath: '#/properties/link/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/link',
                                            schemaPath: '#/properties/link/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.linkType !== undefined) {
                                let data4 = data.linkType;
                                const _errs9 = errors;
                                if (typeof data4 !== 'string') {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/linkType',
                                            schemaPath: '#/properties/linkType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data4 === 'article' || data4 === 'survey' || data4 === 'video' || data4 === 'whitepaper')) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/linkType',
                                            schemaPath: '#/properties/linkType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema29.properties.linkType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.description !== undefined) {
                                    let data5 = data.description;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate12.errors = [
                                                    {
                                                        instancePath: instancePath + '/description',
                                                        schemaPath: '#/properties/description/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/description',
                                                    schemaPath: '#/properties/description/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const benchmarkBubbleSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkBubble',
    type: 'object',
    properties: { growth: { type: 'number' }, efficiency: { type: 'number' }, size: { type: 'number' } },
    required: ['growth', 'efficiency', 'size']
};
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BenchmarkBubble" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.growth === undefined && (missing0 = 'growth')) ||
                (data.efficiency === undefined && (missing0 = 'efficiency')) ||
                (data.size === undefined && (missing0 = 'size'))) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.growth !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.growth == 'number')) {
                        validate13.errors = [
                            {
                                instancePath: instancePath + '/growth',
                                schemaPath: '#/properties/growth/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.efficiency !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.efficiency == 'number')) {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/efficiency',
                                    schemaPath: '#/properties/efficiency/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.size !== undefined) {
                            const _errs5 = errors;
                            if (!(typeof data.size == 'number')) {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/size',
                                        schemaPath: '#/properties/size/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const benchmarkDataSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkData',
    type: 'object',
    properties: {
        industry: { type: 'string', minLength: 1 },
        subIndustry: { type: 'string', minLength: 1 },
        growth: { type: 'number' },
        efficiency: { type: 'number' },
        attainment: { type: 'number' },
        bubbles: { type: 'array', items: { $ref: 'urn:wisepipe-solution-domain:BenchmarkBubble' } }
    },
    required: ['industry', 'subIndustry', 'growth', 'efficiency', 'attainment']
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BenchmarkData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.industry === undefined && (missing0 = 'industry')) ||
                (data.subIndustry === undefined && (missing0 = 'subIndustry')) ||
                (data.growth === undefined && (missing0 = 'growth')) ||
                (data.efficiency === undefined && (missing0 = 'efficiency')) ||
                (data.attainment === undefined && (missing0 = 'attainment'))) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.industry !== undefined) {
                    let data0 = data.industry;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/industry',
                                        schemaPath: '#/properties/industry/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/industry',
                                    schemaPath: '#/properties/industry/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.subIndustry !== undefined) {
                        let data1 = data.subIndustry;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/subIndustry',
                                            schemaPath: '#/properties/subIndustry/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/subIndustry',
                                        schemaPath: '#/properties/subIndustry/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.growth !== undefined) {
                            const _errs5 = errors;
                            if (!(typeof data.growth == 'number')) {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/growth',
                                        schemaPath: '#/properties/growth/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.efficiency !== undefined) {
                                const _errs7 = errors;
                                if (!(typeof data.efficiency == 'number')) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/efficiency',
                                            schemaPath: '#/properties/efficiency/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.attainment !== undefined) {
                                    const _errs9 = errors;
                                    if (!(typeof data.attainment == 'number')) {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/attainment',
                                                schemaPath: '#/properties/attainment/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.bubbles !== undefined) {
                                        let data5 = data.bubbles;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (Array.isArray(data5)) {
                                                var valid1 = true;
                                                const len0 = data5.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    let data6 = data5[i0];
                                                    const _errs13 = errors;
                                                    const _errs14 = errors;
                                                    if (errors === _errs14) {
                                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                            let missing1;
                                                            if ((data6.growth === undefined && (missing1 = 'growth')) ||
                                                                (data6.efficiency === undefined && (missing1 = 'efficiency')) ||
                                                                (data6.size === undefined && (missing1 = 'size'))) {
                                                                validate14.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/bubbles/' + i0,
                                                                        schemaPath: 'urn:wisepipe-solution-domain:BenchmarkBubble/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing1 },
                                                                        message: "must have required property '" + missing1 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data6.growth !== undefined) {
                                                                    const _errs16 = errors;
                                                                    if (!(typeof data6.growth == 'number')) {
                                                                        validate14.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/bubbles/' + i0 + '/growth',
                                                                                schemaPath: 'urn:wisepipe-solution-domain:BenchmarkBubble/properties/growth/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid3 = _errs16 === errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                                if (valid3) {
                                                                    if (data6.efficiency !== undefined) {
                                                                        const _errs18 = errors;
                                                                        if (!(typeof data6.efficiency == 'number')) {
                                                                            validate14.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/bubbles/' + i0 + '/efficiency',
                                                                                    schemaPath: 'urn:wisepipe-solution-domain:BenchmarkBubble/properties/efficiency/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'number' },
                                                                                    message: 'must be number'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid3 = _errs18 === errors;
                                                                    }
                                                                    else {
                                                                        var valid3 = true;
                                                                    }
                                                                    if (valid3) {
                                                                        if (data6.size !== undefined) {
                                                                            const _errs20 = errors;
                                                                            if (!(typeof data6.size == 'number')) {
                                                                                validate14.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/bubbles/' + i0 + '/size',
                                                                                        schemaPath: 'urn:wisepipe-solution-domain:BenchmarkBubble/properties/size/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'number' },
                                                                                        message: 'must be number'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid3 = _errs20 === errors;
                                                                        }
                                                                        else {
                                                                            var valid3 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate14.errors = [
                                                                {
                                                                    instancePath: instancePath + '/bubbles/' + i0,
                                                                    schemaPath: 'urn:wisepipe-solution-domain:BenchmarkBubble/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid1 = _errs13 === errors;
                                                    if (!valid1) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath + '/bubbles',
                                                        schemaPath: '#/properties/bubbles/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const benchmarkExportSchemaValidation = validate15;
const schema33 = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkExport',
    type: 'object',
    properties: {
        companyName: { type: 'string', minLength: 1, maxLength: 100 },
        jobTitle: { type: 'string', minLength: 1, maxLength: 100 },
        country: { type: 'string', minLength: 1, maxLength: 100 },
        state: { type: 'string', maxLength: 100 },
        industry: { type: 'string', minLength: 1 },
        subIndustry: { type: 'string', minLength: 1 },
        growthGoal: { type: 'number', minimum: -10, maximum: 10 },
        growth: { type: 'number' },
        efficiency: { type: 'number' },
        attainment: { type: 'number' },
        enteredDate: { type: 'string', format: 'date-time' },
        email: { type: 'string', maxLength: 100 }
    },
    required: [
        'companyName',
        'jobTitle',
        'country',
        'industry',
        'subIndustry',
        'growth',
        'efficiency',
        'attainment',
        'enteredDate'
    ]
};
const formats0 = formatWrapper['date-time'];
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BenchmarkExport" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.companyName === undefined && (missing0 = 'companyName')) ||
                (data.jobTitle === undefined && (missing0 = 'jobTitle')) ||
                (data.country === undefined && (missing0 = 'country')) ||
                (data.industry === undefined && (missing0 = 'industry')) ||
                (data.subIndustry === undefined && (missing0 = 'subIndustry')) ||
                (data.growth === undefined && (missing0 = 'growth')) ||
                (data.efficiency === undefined && (missing0 = 'efficiency')) ||
                (data.attainment === undefined && (missing0 = 'attainment')) ||
                (data.enteredDate === undefined && (missing0 = 'enteredDate'))) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.companyName !== undefined) {
                    let data0 = data.companyName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 100) {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/companyName',
                                        schemaPath: '#/properties/companyName/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/companyName',
                                            schemaPath: '#/properties/companyName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/companyName',
                                    schemaPath: '#/properties/companyName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.jobTitle !== undefined) {
                        let data1 = data.jobTitle;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/jobTitle',
                                            schemaPath: '#/properties/jobTitle/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/jobTitle',
                                                schemaPath: '#/properties/jobTitle/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/jobTitle',
                                        schemaPath: '#/properties/jobTitle/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.country !== undefined) {
                            let data2 = data.country;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 100) {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/country',
                                                schemaPath: '#/properties/country/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 100 },
                                                message: 'must NOT have more than 100 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/country',
                                                    schemaPath: '#/properties/country/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/country',
                                            schemaPath: '#/properties/country/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.state !== undefined) {
                                let data3 = data.state;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) > 100) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/state',
                                                    schemaPath: '#/properties/state/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 100 },
                                                    message: 'must NOT have more than 100 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/state',
                                                schemaPath: '#/properties/state/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.industry !== undefined) {
                                    let data4 = data.industry;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate15.errors = [
                                                    {
                                                        instancePath: instancePath + '/industry',
                                                        schemaPath: '#/properties/industry/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/industry',
                                                    schemaPath: '#/properties/industry/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.subIndustry !== undefined) {
                                        let data5 = data.subIndustry;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate15.errors = [
                                                        {
                                                            instancePath: instancePath + '/subIndustry',
                                                            schemaPath: '#/properties/subIndustry/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate15.errors = [
                                                    {
                                                        instancePath: instancePath + '/subIndustry',
                                                        schemaPath: '#/properties/subIndustry/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.growthGoal !== undefined) {
                                            let data6 = data.growthGoal;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 == 'number') {
                                                    if (data6 > 10 || isNaN(data6)) {
                                                        validate15.errors = [
                                                            {
                                                                instancePath: instancePath + '/growthGoal',
                                                                schemaPath: '#/properties/growthGoal/maximum',
                                                                keyword: 'maximum',
                                                                params: { comparison: '<=', limit: 10 },
                                                                message: 'must be <= 10'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data6 < -10 || isNaN(data6)) {
                                                            validate15.errors = [
                                                                {
                                                                    instancePath: instancePath + '/growthGoal',
                                                                    schemaPath: '#/properties/growthGoal/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: -10 },
                                                                    message: 'must be >= -10'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate15.errors = [
                                                        {
                                                            instancePath: instancePath + '/growthGoal',
                                                            schemaPath: '#/properties/growthGoal/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.growth !== undefined) {
                                                const _errs15 = errors;
                                                if (!(typeof data.growth == 'number')) {
                                                    validate15.errors = [
                                                        {
                                                            instancePath: instancePath + '/growth',
                                                            schemaPath: '#/properties/growth/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.efficiency !== undefined) {
                                                    const _errs17 = errors;
                                                    if (!(typeof data.efficiency == 'number')) {
                                                        validate15.errors = [
                                                            {
                                                                instancePath: instancePath + '/efficiency',
                                                                schemaPath: '#/properties/efficiency/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.attainment !== undefined) {
                                                        const _errs19 = errors;
                                                        if (!(typeof data.attainment == 'number')) {
                                                            validate15.errors = [
                                                                {
                                                                    instancePath: instancePath + '/attainment',
                                                                    schemaPath: '#/properties/attainment/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.enteredDate !== undefined) {
                                                            let data10 = data.enteredDate;
                                                            const _errs21 = errors;
                                                            if (errors === _errs21) {
                                                                if (errors === _errs21) {
                                                                    if (typeof data10 === 'string') {
                                                                        if (!formats0.validate(data10)) {
                                                                            validate15.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/enteredDate',
                                                                                    schemaPath: '#/properties/enteredDate/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate15.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/enteredDate',
                                                                                schemaPath: '#/properties/enteredDate/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid0 = _errs21 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.email !== undefined) {
                                                                let data11 = data.email;
                                                                const _errs23 = errors;
                                                                if (errors === _errs23) {
                                                                    if (typeof data11 === 'string') {
                                                                        if (func2(data11) > 100) {
                                                                            validate15.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/email',
                                                                                    schemaPath: '#/properties/email/maxLength',
                                                                                    keyword: 'maxLength',
                                                                                    params: { limit: 100 },
                                                                                    message: 'must NOT have more than 100 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate15.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/email',
                                                                                schemaPath: '#/properties/email/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs23 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const benchmarkUserExportSchemaValidation = validate16;
const schema34 = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkUserExport',
    type: 'object',
    properties: {
        email: { type: 'string', minLength: 1, maxLength: 100 },
        firstName: { type: 'string', minLength: 1, maxLength: 100 },
        lastName: { type: 'string', minLength: 1, maxLength: 100 },
        company: { type: 'string', minLength: 1, maxLength: 100 },
        jobTitle: { type: 'string', minLength: 1, maxLength: 100 },
        country: { type: 'string', minLength: 1, maxLength: 100 },
        city: { type: 'string', minLength: 1, maxLength: 100 },
        areaOfInterest: { type: 'string', minLength: 1, maxLength: 100 },
        comments: { type: 'string', maxLength: 500 },
        enteredDate: { type: 'string', format: 'date-time' }
    },
    required: [
        'email',
        'firstName',
        'lastName',
        'company',
        'jobTitle',
        'country',
        'city',
        'areaOfInterest',
        'enteredDate'
    ]
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BenchmarkUserExport" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.email === undefined && (missing0 = 'email')) ||
                (data.firstName === undefined && (missing0 = 'firstName')) ||
                (data.lastName === undefined && (missing0 = 'lastName')) ||
                (data.company === undefined && (missing0 = 'company')) ||
                (data.jobTitle === undefined && (missing0 = 'jobTitle')) ||
                (data.country === undefined && (missing0 = 'country')) ||
                (data.city === undefined && (missing0 = 'city')) ||
                (data.areaOfInterest === undefined && (missing0 = 'areaOfInterest')) ||
                (data.enteredDate === undefined && (missing0 = 'enteredDate'))) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.email !== undefined) {
                    let data0 = data.email;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 100) {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/email',
                                        schemaPath: '#/properties/email/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/email',
                                            schemaPath: '#/properties/email/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate16.errors = [
                                {
                                    instancePath: instancePath + '/email',
                                    schemaPath: '#/properties/email/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.firstName !== undefined) {
                        let data1 = data.firstName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/firstName',
                                            schemaPath: '#/properties/firstName/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/firstName',
                                                schemaPath: '#/properties/firstName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/firstName',
                                        schemaPath: '#/properties/firstName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.lastName !== undefined) {
                            let data2 = data.lastName;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 100) {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/lastName',
                                                schemaPath: '#/properties/lastName/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 100 },
                                                message: 'must NOT have more than 100 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/lastName',
                                                    schemaPath: '#/properties/lastName/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/lastName',
                                            schemaPath: '#/properties/lastName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.company !== undefined) {
                                let data3 = data.company;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) > 100) {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/company',
                                                    schemaPath: '#/properties/company/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 100 },
                                                    message: 'must NOT have more than 100 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (func2(data3) < 1) {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/company',
                                                        schemaPath: '#/properties/company/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/company',
                                                schemaPath: '#/properties/company/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.jobTitle !== undefined) {
                                    let data4 = data.jobTitle;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) > 100) {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/jobTitle',
                                                        schemaPath: '#/properties/jobTitle/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 100 },
                                                        message: 'must NOT have more than 100 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data4) < 1) {
                                                    validate16.errors = [
                                                        {
                                                            instancePath: instancePath + '/jobTitle',
                                                            schemaPath: '#/properties/jobTitle/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/jobTitle',
                                                    schemaPath: '#/properties/jobTitle/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.country !== undefined) {
                                        let data5 = data.country;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) > 100) {
                                                    validate16.errors = [
                                                        {
                                                            instancePath: instancePath + '/country',
                                                            schemaPath: '#/properties/country/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 100 },
                                                            message: 'must NOT have more than 100 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data5) < 1) {
                                                        validate16.errors = [
                                                            {
                                                                instancePath: instancePath + '/country',
                                                                schemaPath: '#/properties/country/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/country',
                                                        schemaPath: '#/properties/country/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.city !== undefined) {
                                            let data6 = data.city;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) > 100) {
                                                        validate16.errors = [
                                                            {
                                                                instancePath: instancePath + '/city',
                                                                schemaPath: '#/properties/city/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 100 },
                                                                message: 'must NOT have more than 100 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (func2(data6) < 1) {
                                                            validate16.errors = [
                                                                {
                                                                    instancePath: instancePath + '/city',
                                                                    schemaPath: '#/properties/city/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate16.errors = [
                                                        {
                                                            instancePath: instancePath + '/city',
                                                            schemaPath: '#/properties/city/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.areaOfInterest !== undefined) {
                                                let data7 = data.areaOfInterest;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (typeof data7 === 'string') {
                                                        if (func2(data7) > 100) {
                                                            validate16.errors = [
                                                                {
                                                                    instancePath: instancePath + '/areaOfInterest',
                                                                    schemaPath: '#/properties/areaOfInterest/maxLength',
                                                                    keyword: 'maxLength',
                                                                    params: { limit: 100 },
                                                                    message: 'must NOT have more than 100 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (func2(data7) < 1) {
                                                                validate16.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/areaOfInterest',
                                                                        schemaPath: '#/properties/areaOfInterest/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate16.errors = [
                                                            {
                                                                instancePath: instancePath + '/areaOfInterest',
                                                                schemaPath: '#/properties/areaOfInterest/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.comments !== undefined) {
                                                    let data8 = data.comments;
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (typeof data8 === 'string') {
                                                            if (func2(data8) > 500) {
                                                                validate16.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/comments',
                                                                        schemaPath: '#/properties/comments/maxLength',
                                                                        keyword: 'maxLength',
                                                                        params: { limit: 500 },
                                                                        message: 'must NOT have more than 500 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate16.errors = [
                                                                {
                                                                    instancePath: instancePath + '/comments',
                                                                    schemaPath: '#/properties/comments/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.enteredDate !== undefined) {
                                                        let data9 = data.enteredDate;
                                                        const _errs19 = errors;
                                                        if (errors === _errs19) {
                                                            if (errors === _errs19) {
                                                                if (typeof data9 === 'string') {
                                                                    if (!formats0.validate(data9)) {
                                                                        validate16.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/enteredDate',
                                                                                schemaPath: '#/properties/enteredDate/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate16.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/enteredDate',
                                                                            schemaPath: '#/properties/enteredDate/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const benchmarkUserPatchSchemaValidation = validate17;
const schema35 = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkUserPatch',
    type: 'object',
    properties: {
        firstName: { type: 'string', maxLength: 100 },
        lastName: { type: 'string', maxLength: 100 },
        company: { type: 'string', maxLength: 100 },
        jobTitle: { type: 'string', maxLength: 100 },
        country: { type: 'string', maxLength: 100 },
        city: { type: 'string', maxLength: 100 },
        areaOfInterest: { type: 'string', maxLength: 100 },
        growthGoal: { type: 'number', minimum: -10, maximum: 10 },
        comments: { type: 'string', maxLength: 500 },
        marketingAccepted: { type: 'boolean' }
    }
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BenchmarkUserPatch" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.firstName !== undefined) {
                let data0 = data.firstName;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) > 100) {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/firstName',
                                    schemaPath: '#/properties/firstName/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 100 },
                                    message: 'must NOT have more than 100 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate17.errors = [
                            {
                                instancePath: instancePath + '/firstName',
                                schemaPath: '#/properties/firstName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.lastName !== undefined) {
                    let data1 = data.lastName;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) > 100) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/lastName',
                                        schemaPath: '#/properties/lastName/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/lastName',
                                    schemaPath: '#/properties/lastName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.company !== undefined) {
                        let data2 = data.company;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) > 100) {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/company',
                                            schemaPath: '#/properties/company/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/company',
                                        schemaPath: '#/properties/company/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.jobTitle !== undefined) {
                            let data3 = data.jobTitle;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 100) {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/jobTitle',
                                                schemaPath: '#/properties/jobTitle/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 100 },
                                                message: 'must NOT have more than 100 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/jobTitle',
                                            schemaPath: '#/properties/jobTitle/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.country !== undefined) {
                                let data4 = data.country;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) > 100) {
                                            validate17.errors = [
                                                {
                                                    instancePath: instancePath + '/country',
                                                    schemaPath: '#/properties/country/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 100 },
                                                    message: 'must NOT have more than 100 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/country',
                                                schemaPath: '#/properties/country/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.city !== undefined) {
                                    let data5 = data.city;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) > 100) {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/city',
                                                        schemaPath: '#/properties/city/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 100 },
                                                        message: 'must NOT have more than 100 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate17.errors = [
                                                {
                                                    instancePath: instancePath + '/city',
                                                    schemaPath: '#/properties/city/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.areaOfInterest !== undefined) {
                                        let data6 = data.areaOfInterest;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data6 === 'string') {
                                                if (func2(data6) > 100) {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/areaOfInterest',
                                                            schemaPath: '#/properties/areaOfInterest/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 100 },
                                                            message: 'must NOT have more than 100 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/areaOfInterest',
                                                        schemaPath: '#/properties/areaOfInterest/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.growthGoal !== undefined) {
                                            let data7 = data.growthGoal;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data7 == 'number') {
                                                    if (data7 > 10 || isNaN(data7)) {
                                                        validate17.errors = [
                                                            {
                                                                instancePath: instancePath + '/growthGoal',
                                                                schemaPath: '#/properties/growthGoal/maximum',
                                                                keyword: 'maximum',
                                                                params: { comparison: '<=', limit: 10 },
                                                                message: 'must be <= 10'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data7 < -10 || isNaN(data7)) {
                                                            validate17.errors = [
                                                                {
                                                                    instancePath: instancePath + '/growthGoal',
                                                                    schemaPath: '#/properties/growthGoal/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: -10 },
                                                                    message: 'must be >= -10'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/growthGoal',
                                                            schemaPath: '#/properties/growthGoal/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.comments !== undefined) {
                                                let data8 = data.comments;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (typeof data8 === 'string') {
                                                        if (func2(data8) > 500) {
                                                            validate17.errors = [
                                                                {
                                                                    instancePath: instancePath + '/comments',
                                                                    schemaPath: '#/properties/comments/maxLength',
                                                                    keyword: 'maxLength',
                                                                    params: { limit: 500 },
                                                                    message: 'must NOT have more than 500 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate17.errors = [
                                                            {
                                                                instancePath: instancePath + '/comments',
                                                                schemaPath: '#/properties/comments/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.marketingAccepted !== undefined) {
                                                    const _errs19 = errors;
                                                    if (typeof data.marketingAccepted !== 'boolean') {
                                                        validate17.errors = [
                                                            {
                                                                instancePath: instancePath + '/marketingAccepted',
                                                                schemaPath: '#/properties/marketingAccepted/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs19 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const benchmarkUserSchemaValidation = validate18;
const schema36 = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkUser',
    type: 'object',
    properties: {
        email: { type: 'string', minLength: 1, maxLength: 100 },
        benchmarksCreated: { type: 'number' },
        benchmarksMax: { type: 'number' },
        verified: { type: 'boolean' },
        marketingAccepted: { type: 'boolean' },
        firstName: { type: 'string', maxLength: 100 },
        lastName: { type: 'string', maxLength: 100 },
        company: { type: 'string', maxLength: 100 },
        jobTitle: { type: 'string', maxLength: 100 },
        country: { type: 'string', maxLength: 100 },
        city: { type: 'string', maxLength: 100 },
        areaOfInterest: { type: 'string', maxLength: 100 },
        growthGoal: { type: 'number', minimum: -10, maximum: 10 },
        comments: { type: 'string', maxLength: 500 }
    }
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BenchmarkUser" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.email !== undefined) {
                let data0 = data.email;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) > 100) {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/email',
                                    schemaPath: '#/properties/email/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 100 },
                                    message: 'must NOT have more than 100 characters'
                                }
                            ];
                            return false;
                        }
                        else {
                            if (func2(data0) < 1) {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/email',
                                        schemaPath: '#/properties/email/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    else {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/email',
                                schemaPath: '#/properties/email/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.benchmarksCreated !== undefined) {
                    const _errs3 = errors;
                    if (!(typeof data.benchmarksCreated == 'number')) {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/benchmarksCreated',
                                schemaPath: '#/properties/benchmarksCreated/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.benchmarksMax !== undefined) {
                        const _errs5 = errors;
                        if (!(typeof data.benchmarksMax == 'number')) {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/benchmarksMax',
                                    schemaPath: '#/properties/benchmarksMax/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.verified !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.verified !== 'boolean') {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/verified',
                                        schemaPath: '#/properties/verified/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.marketingAccepted !== undefined) {
                                const _errs9 = errors;
                                if (typeof data.marketingAccepted !== 'boolean') {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/marketingAccepted',
                                            schemaPath: '#/properties/marketingAccepted/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.firstName !== undefined) {
                                    let data5 = data.firstName;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) > 100) {
                                                validate18.errors = [
                                                    {
                                                        instancePath: instancePath + '/firstName',
                                                        schemaPath: '#/properties/firstName/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 100 },
                                                        message: 'must NOT have more than 100 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate18.errors = [
                                                {
                                                    instancePath: instancePath + '/firstName',
                                                    schemaPath: '#/properties/firstName/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.lastName !== undefined) {
                                        let data6 = data.lastName;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data6 === 'string') {
                                                if (func2(data6) > 100) {
                                                    validate18.errors = [
                                                        {
                                                            instancePath: instancePath + '/lastName',
                                                            schemaPath: '#/properties/lastName/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 100 },
                                                            message: 'must NOT have more than 100 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate18.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastName',
                                                        schemaPath: '#/properties/lastName/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.company !== undefined) {
                                            let data7 = data.company;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data7 === 'string') {
                                                    if (func2(data7) > 100) {
                                                        validate18.errors = [
                                                            {
                                                                instancePath: instancePath + '/company',
                                                                schemaPath: '#/properties/company/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 100 },
                                                                message: 'must NOT have more than 100 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate18.errors = [
                                                        {
                                                            instancePath: instancePath + '/company',
                                                            schemaPath: '#/properties/company/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.jobTitle !== undefined) {
                                                let data8 = data.jobTitle;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (typeof data8 === 'string') {
                                                        if (func2(data8) > 100) {
                                                            validate18.errors = [
                                                                {
                                                                    instancePath: instancePath + '/jobTitle',
                                                                    schemaPath: '#/properties/jobTitle/maxLength',
                                                                    keyword: 'maxLength',
                                                                    params: { limit: 100 },
                                                                    message: 'must NOT have more than 100 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate18.errors = [
                                                            {
                                                                instancePath: instancePath + '/jobTitle',
                                                                schemaPath: '#/properties/jobTitle/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.country !== undefined) {
                                                    let data9 = data.country;
                                                    const _errs19 = errors;
                                                    if (errors === _errs19) {
                                                        if (typeof data9 === 'string') {
                                                            if (func2(data9) > 100) {
                                                                validate18.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/country',
                                                                        schemaPath: '#/properties/country/maxLength',
                                                                        keyword: 'maxLength',
                                                                        params: { limit: 100 },
                                                                        message: 'must NOT have more than 100 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate18.errors = [
                                                                {
                                                                    instancePath: instancePath + '/country',
                                                                    schemaPath: '#/properties/country/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs19 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.city !== undefined) {
                                                        let data10 = data.city;
                                                        const _errs21 = errors;
                                                        if (errors === _errs21) {
                                                            if (typeof data10 === 'string') {
                                                                if (func2(data10) > 100) {
                                                                    validate18.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/city',
                                                                            schemaPath: '#/properties/city/maxLength',
                                                                            keyword: 'maxLength',
                                                                            params: { limit: 100 },
                                                                            message: 'must NOT have more than 100 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate18.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/city',
                                                                        schemaPath: '#/properties/city/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs21 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.areaOfInterest !== undefined) {
                                                            let data11 = data.areaOfInterest;
                                                            const _errs23 = errors;
                                                            if (errors === _errs23) {
                                                                if (typeof data11 === 'string') {
                                                                    if (func2(data11) > 100) {
                                                                        validate18.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/areaOfInterest',
                                                                                schemaPath: '#/properties/areaOfInterest/maxLength',
                                                                                keyword: 'maxLength',
                                                                                params: { limit: 100 },
                                                                                message: 'must NOT have more than 100 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate18.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/areaOfInterest',
                                                                            schemaPath: '#/properties/areaOfInterest/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs23 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.growthGoal !== undefined) {
                                                                let data12 = data.growthGoal;
                                                                const _errs25 = errors;
                                                                if (errors === _errs25) {
                                                                    if (typeof data12 == 'number') {
                                                                        if (data12 > 10 || isNaN(data12)) {
                                                                            validate18.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/growthGoal',
                                                                                    schemaPath: '#/properties/growthGoal/maximum',
                                                                                    keyword: 'maximum',
                                                                                    params: { comparison: '<=', limit: 10 },
                                                                                    message: 'must be <= 10'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (data12 < -10 || isNaN(data12)) {
                                                                                validate18.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/growthGoal',
                                                                                        schemaPath: '#/properties/growthGoal/minimum',
                                                                                        keyword: 'minimum',
                                                                                        params: { comparison: '>=', limit: -10 },
                                                                                        message: 'must be >= -10'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate18.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/growthGoal',
                                                                                schemaPath: '#/properties/growthGoal/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs25 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.comments !== undefined) {
                                                                    let data13 = data.comments;
                                                                    const _errs27 = errors;
                                                                    if (errors === _errs27) {
                                                                        if (typeof data13 === 'string') {
                                                                            if (func2(data13) > 500) {
                                                                                validate18.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/comments',
                                                                                        schemaPath: '#/properties/comments/maxLength',
                                                                                        keyword: 'maxLength',
                                                                                        params: { limit: 500 },
                                                                                        message: 'must NOT have more than 500 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate18.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/comments',
                                                                                    schemaPath: '#/properties/comments/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid0 = _errs27 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const benchmarkingParamsSchemaValidation = validate19;
const schema37 = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkingParams',
    type: 'object',
    properties: {
        companyName: { type: 'string', minLength: 1, maxLength: 100 },
        jobTitle: { type: 'string', minLength: 1, maxLength: 100 },
        country: { type: 'string', maxLength: 100 },
        state: { type: 'string', maxLength: 100 },
        industry: { type: 'string', minLength: 1 },
        subIndustry: { type: 'string', minLength: 1 },
        growthGoal: { type: 'number', minimum: -10, maximum: 10 },
        sellerColumn: { type: 'string' },
        costColumn: { type: 'string' },
        attainmentColumn: { type: 'string' },
        revenueColumn: { type: 'string' },
        dateColumn: { type: 'string' },
        dateStartValue: { type: 'string' },
        geographyColumn: { type: 'string' },
        businessUnitColumn: { type: 'string' },
        costValue: { type: 'number', minimum: 0 },
        attainmentValue: { type: 'number', minimum: 0, maximum: 1 },
        revenueValue: { type: 'number', minimum: 0 },
        revenuePrevValue: { type: 'number', minimum: 0 },
        marketingAccepted: { type: 'boolean' },
        email: { type: 'string', maxLength: 100 },
        lastUpdated: { type: 'number' }
    },
    required: []
};
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BenchmarkingParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.companyName !== undefined) {
                let data0 = data.companyName;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) > 100) {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/companyName',
                                    schemaPath: '#/properties/companyName/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 100 },
                                    message: 'must NOT have more than 100 characters'
                                }
                            ];
                            return false;
                        }
                        else {
                            if (func2(data0) < 1) {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/companyName',
                                        schemaPath: '#/properties/companyName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    else {
                        validate19.errors = [
                            {
                                instancePath: instancePath + '/companyName',
                                schemaPath: '#/properties/companyName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.jobTitle !== undefined) {
                    let data1 = data.jobTitle;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) > 100) {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/jobTitle',
                                        schemaPath: '#/properties/jobTitle/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data1) < 1) {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/jobTitle',
                                            schemaPath: '#/properties/jobTitle/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/jobTitle',
                                    schemaPath: '#/properties/jobTitle/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.country !== undefined) {
                        let data2 = data.country;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) > 100) {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/country',
                                            schemaPath: '#/properties/country/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/country',
                                        schemaPath: '#/properties/country/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.state !== undefined) {
                            let data3 = data.state;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 100) {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/state',
                                                schemaPath: '#/properties/state/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 100 },
                                                message: 'must NOT have more than 100 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/state',
                                            schemaPath: '#/properties/state/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.industry !== undefined) {
                                let data4 = data.industry;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate19.errors = [
                                                {
                                                    instancePath: instancePath + '/industry',
                                                    schemaPath: '#/properties/industry/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/industry',
                                                schemaPath: '#/properties/industry/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.subIndustry !== undefined) {
                                    let data5 = data.subIndustry;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/subIndustry',
                                                        schemaPath: '#/properties/subIndustry/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate19.errors = [
                                                {
                                                    instancePath: instancePath + '/subIndustry',
                                                    schemaPath: '#/properties/subIndustry/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.growthGoal !== undefined) {
                                        let data6 = data.growthGoal;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data6 == 'number') {
                                                if (data6 > 10 || isNaN(data6)) {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/growthGoal',
                                                            schemaPath: '#/properties/growthGoal/maximum',
                                                            keyword: 'maximum',
                                                            params: { comparison: '<=', limit: 10 },
                                                            message: 'must be <= 10'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data6 < -10 || isNaN(data6)) {
                                                        validate19.errors = [
                                                            {
                                                                instancePath: instancePath + '/growthGoal',
                                                                schemaPath: '#/properties/growthGoal/minimum',
                                                                keyword: 'minimum',
                                                                params: { comparison: '>=', limit: -10 },
                                                                message: 'must be >= -10'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/growthGoal',
                                                        schemaPath: '#/properties/growthGoal/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.sellerColumn !== undefined) {
                                            const _errs15 = errors;
                                            if (typeof data.sellerColumn !== 'string') {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/sellerColumn',
                                                        schemaPath: '#/properties/sellerColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.costColumn !== undefined) {
                                                const _errs17 = errors;
                                                if (typeof data.costColumn !== 'string') {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/costColumn',
                                                            schemaPath: '#/properties/costColumn/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.attainmentColumn !== undefined) {
                                                    const _errs19 = errors;
                                                    if (typeof data.attainmentColumn !== 'string') {
                                                        validate19.errors = [
                                                            {
                                                                instancePath: instancePath + '/attainmentColumn',
                                                                schemaPath: '#/properties/attainmentColumn/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs19 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.revenueColumn !== undefined) {
                                                        const _errs21 = errors;
                                                        if (typeof data.revenueColumn !== 'string') {
                                                            validate19.errors = [
                                                                {
                                                                    instancePath: instancePath + '/revenueColumn',
                                                                    schemaPath: '#/properties/revenueColumn/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs21 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.dateColumn !== undefined) {
                                                            const _errs23 = errors;
                                                            if (typeof data.dateColumn !== 'string') {
                                                                validate19.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/dateColumn',
                                                                        schemaPath: '#/properties/dateColumn/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs23 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.dateStartValue !== undefined) {
                                                                const _errs25 = errors;
                                                                if (typeof data.dateStartValue !== 'string') {
                                                                    validate19.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/dateStartValue',
                                                                            schemaPath: '#/properties/dateStartValue/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs25 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.geographyColumn !== undefined) {
                                                                    const _errs27 = errors;
                                                                    if (typeof data.geographyColumn !== 'string') {
                                                                        validate19.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/geographyColumn',
                                                                                schemaPath: '#/properties/geographyColumn/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid0 = _errs27 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.businessUnitColumn !== undefined) {
                                                                        const _errs29 = errors;
                                                                        if (typeof data.businessUnitColumn !== 'string') {
                                                                            validate19.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/businessUnitColumn',
                                                                                    schemaPath: '#/properties/businessUnitColumn/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid0 = _errs29 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.costValue !== undefined) {
                                                                            let data15 = data.costValue;
                                                                            const _errs31 = errors;
                                                                            if (errors === _errs31) {
                                                                                if (typeof data15 == 'number') {
                                                                                    if (data15 < 0 || isNaN(data15)) {
                                                                                        validate19.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/costValue',
                                                                                                schemaPath: '#/properties/costValue/minimum',
                                                                                                keyword: 'minimum',
                                                                                                params: { comparison: '>=', limit: 0 },
                                                                                                message: 'must be >= 0'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate19.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/costValue',
                                                                                            schemaPath: '#/properties/costValue/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'number' },
                                                                                            message: 'must be number'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid0 = _errs31 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.attainmentValue !== undefined) {
                                                                                let data16 = data.attainmentValue;
                                                                                const _errs33 = errors;
                                                                                if (errors === _errs33) {
                                                                                    if (typeof data16 == 'number') {
                                                                                        if (data16 > 1 || isNaN(data16)) {
                                                                                            validate19.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/attainmentValue',
                                                                                                    schemaPath: '#/properties/attainmentValue/maximum',
                                                                                                    keyword: 'maximum',
                                                                                                    params: { comparison: '<=', limit: 1 },
                                                                                                    message: 'must be <= 1'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            if (data16 < 0 || isNaN(data16)) {
                                                                                                validate19.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/attainmentValue',
                                                                                                        schemaPath: '#/properties/attainmentValue/minimum',
                                                                                                        keyword: 'minimum',
                                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                                        message: 'must be >= 0'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate19.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/attainmentValue',
                                                                                                schemaPath: '#/properties/attainmentValue/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'number' },
                                                                                                message: 'must be number'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid0 = _errs33 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.revenueValue !== undefined) {
                                                                                    let data17 = data.revenueValue;
                                                                                    const _errs35 = errors;
                                                                                    if (errors === _errs35) {
                                                                                        if (typeof data17 == 'number') {
                                                                                            if (data17 < 0 || isNaN(data17)) {
                                                                                                validate19.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/revenueValue',
                                                                                                        schemaPath: '#/properties/revenueValue/minimum',
                                                                                                        keyword: 'minimum',
                                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                                        message: 'must be >= 0'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate19.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/revenueValue',
                                                                                                    schemaPath: '#/properties/revenueValue/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'number' },
                                                                                                    message: 'must be number'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid0 = _errs35 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                                if (valid0) {
                                                                                    if (data.revenuePrevValue !== undefined) {
                                                                                        let data18 = data.revenuePrevValue;
                                                                                        const _errs37 = errors;
                                                                                        if (errors === _errs37) {
                                                                                            if (typeof data18 == 'number') {
                                                                                                if (data18 < 0 || isNaN(data18)) {
                                                                                                    validate19.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/revenuePrevValue',
                                                                                                            schemaPath: '#/properties/revenuePrevValue/minimum',
                                                                                                            keyword: 'minimum',
                                                                                                            params: { comparison: '>=', limit: 0 },
                                                                                                            message: 'must be >= 0'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate19.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/revenuePrevValue',
                                                                                                        schemaPath: '#/properties/revenuePrevValue/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'number' },
                                                                                                        message: 'must be number'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid0 = _errs37 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid0 = true;
                                                                                    }
                                                                                    if (valid0) {
                                                                                        if (data.marketingAccepted !== undefined) {
                                                                                            const _errs39 = errors;
                                                                                            if (typeof data.marketingAccepted !== 'boolean') {
                                                                                                validate19.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/marketingAccepted',
                                                                                                        schemaPath: '#/properties/marketingAccepted/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'boolean' },
                                                                                                        message: 'must be boolean'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid0 = _errs39 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid0 = true;
                                                                                        }
                                                                                        if (valid0) {
                                                                                            if (data.email !== undefined) {
                                                                                                let data20 = data.email;
                                                                                                const _errs41 = errors;
                                                                                                if (errors === _errs41) {
                                                                                                    if (typeof data20 === 'string') {
                                                                                                        if (func2(data20) > 100) {
                                                                                                            validate19.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/email',
                                                                                                                    schemaPath: '#/properties/email/maxLength',
                                                                                                                    keyword: 'maxLength',
                                                                                                                    params: { limit: 100 },
                                                                                                                    message: 'must NOT have more than 100 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate19.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/email',
                                                                                                                schemaPath: '#/properties/email/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid0 = _errs41 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid0 = true;
                                                                                            }
                                                                                            if (valid0) {
                                                                                                if (data.lastUpdated !== undefined) {
                                                                                                    const _errs43 = errors;
                                                                                                    if (!(typeof data.lastUpdated == 'number')) {
                                                                                                        validate19.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/lastUpdated',
                                                                                                                schemaPath: '#/properties/lastUpdated/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'number' },
                                                                                                                message: 'must be number'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid0 = _errs43 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid0 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const blueprintRequestSchemaValidation = validate20;
const schema38 = {
    $id: 'urn:wisepipe-solution-domain:BlueprintRequest',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 100 },
        type: {
            type: 'string',
            enum: [
                'payoutOutlier',
                'adjustmentOutlier',
                'transactionOutlier',
                'revenueVsPayout',
                'forecasting',
                'leadScoring',
                'sellerCapacity',
                'l2rOpportunityScores',
                'smartMatcher',
                'combinationMatcher',
                'asc606Amortization',
                'asc606Preparation',
                'financialAdvisorTurnover',
                'customerLifetimeValue',
                'dealValueChanges',
                'discountingDiagnostics',
                'opportunityScores',
                'fuzzyMatcher',
                'rosterValidation',
                'orderConsolidation',
                'recordAndAdjustment',
                'identifyNewHires',
                'trackTerritoryChanges',
                'transactionReconciliation',
                'transactionValidation',
                'entityResolution',
                'hierarchyCreation',
                'hierarchyValidator'
            ]
        },
        engineMode: { type: 'string', enum: ['standard', 'big'] },
        version: { type: 'number', minimum: 1, maximum: 1 }
    },
    required: ['name', 'type', 'engineMode']
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BlueprintRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.engineMode === undefined && (missing0 = 'engineMode'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 100) {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate20.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.type !== undefined) {
                        let data1 = data.type;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate20.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'payoutOutlier' ||
                            data1 === 'adjustmentOutlier' ||
                            data1 === 'transactionOutlier' ||
                            data1 === 'revenueVsPayout' ||
                            data1 === 'forecasting' ||
                            data1 === 'leadScoring' ||
                            data1 === 'sellerCapacity' ||
                            data1 === 'l2rOpportunityScores' ||
                            data1 === 'smartMatcher' ||
                            data1 === 'combinationMatcher' ||
                            data1 === 'asc606Amortization' ||
                            data1 === 'asc606Preparation' ||
                            data1 === 'financialAdvisorTurnover' ||
                            data1 === 'customerLifetimeValue' ||
                            data1 === 'dealValueChanges' ||
                            data1 === 'discountingDiagnostics' ||
                            data1 === 'opportunityScores' ||
                            data1 === 'fuzzyMatcher' ||
                            data1 === 'rosterValidation' ||
                            data1 === 'orderConsolidation' ||
                            data1 === 'recordAndAdjustment' ||
                            data1 === 'identifyNewHires' ||
                            data1 === 'trackTerritoryChanges' ||
                            data1 === 'transactionReconciliation' ||
                            data1 === 'transactionValidation' ||
                            data1 === 'entityResolution' ||
                            data1 === 'hierarchyCreation' ||
                            data1 === 'hierarchyValidator')) {
                            validate20.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema38.properties.type.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.engineMode !== undefined) {
                            let data2 = data.engineMode;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/engineMode',
                                        schemaPath: '#/properties/engineMode/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'standard' || data2 === 'big')) {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/engineMode',
                                        schemaPath: '#/properties/engineMode/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema38.properties.engineMode.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.version !== undefined) {
                                let data3 = data.version;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 > 1 || isNaN(data3)) {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath + '/version',
                                                    schemaPath: '#/properties/version/maximum',
                                                    keyword: 'maximum',
                                                    params: { comparison: '<=', limit: 1 },
                                                    message: 'must be <= 1'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data3 < 1 || isNaN(data3)) {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/version',
                                                        schemaPath: '#/properties/version/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 1 },
                                                        message: 'must be >= 1'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/version',
                                                schemaPath: '#/properties/version/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const blueprintResponseSchemaValidation = validate21;
const schema39 = {
    $id: 'urn:wisepipe-solution-domain:BlueprintResponse',
    type: 'object',
    properties: {
        pipe: { $ref: 'urn:wisepipe-base-pipe:Pipe' },
        originIDs: { type: 'array', items: { type: 'string', uid: 9 } },
        visualizationIDs: { type: 'array', items: { type: 'string', uid: 9 } }
    },
    required: ['pipe', 'originIDs', 'visualizationIDs']
};
const schema40 = {
    $id: 'urn:wisepipe-base-pipe:Pipe',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        engineMode: { type: 'string', enum: ['standard', 'big'] },
        createdAt: { type: 'string', format: 'date-time' },
        description: { type: 'string', maxLength: 1000 },
        documentation: { $ref: 'urn:wisepipe-base-pipe:PipeDocumentation' },
        image: { type: 'string', maxLength: 1024 },
        imageUrl: { type: 'string' },
        rowVersion: { type: 'number', minimum: 0 },
        challengeData: { $ref: 'urn:wisepipe-base-pipe:ChallengeData' },
        parentFolderID: { type: 'string', uid: 9 },
        isEditor: { type: 'boolean' },
        isPublic: { type: 'boolean' }
    },
    required: ['pipeID', 'name', 'createdAt', 'engineMode', 'rowVersion']
};
const schema41 = {
    $id: 'urn:wisepipe-base-pipe:PipeDocumentation',
    type: 'object',
    properties: {
        lastModified: { type: 'string', format: 'date-time' },
        content: { type: 'string', minLength: 1, maxLength: 50000 }
    },
    required: ['lastModified', 'content']
};
const schema42 = {
    $id: 'urn:wisepipe-base-pipe:ChallengeData',
    type: 'object',
    properties: {
        challengeID: { type: 'number', minimum: 1 },
        userID: { type: 'string', minLength: 1, maxLength: 128 },
        dataSourceID: { type: 'string', uid: 9 },
        originID: { type: 'string', uid: 9 },
        createdAt: { type: 'string', format: 'date-time' },
        lastUpdatedAt: { type: 'string', format: 'date-time' },
        percentComplete: { type: 'number', minimum: 0, maximum: 100 },
        state: { type: 'string', enum: ['not_started', 'started', 'complete'] }
    },
    required: ['challengeID', 'percentComplete']
};
const func64 = ucs2length;
const func65 = base64urlToBuffer;
const func66 = base64urlEncode;
const func67 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func76 = ucs2length;
const func77 = base64urlToBuffer;
const func78 = base64urlEncode;
const func79 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func80 = ucs2length;
const func81 = base64urlToBuffer;
const func82 = base64urlEncode;
const func83 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func84 = ucs2length;
const func85 = base64urlToBuffer;
const func86 = base64urlEncode;
const func87 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:Pipe" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt')) ||
                (data.engineMode === undefined && (missing0 = 'engineMode')) ||
                (data.rowVersion === undefined && (missing0 = 'rowVersion'))) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func64(data0) < b64min0 || func64(data0) > b64max0) {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func64(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func64(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func65(data0);
                                if (decoded0.length !== 10) {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func66(decoded0);
                                    if (func67(encoded0) !== func67(data0)) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate22.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.engineMode !== undefined) {
                            let data2 = data.engineMode;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/engineMode',
                                        schemaPath: '#/properties/engineMode/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'standard' || data2 === 'big')) {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/engineMode',
                                        schemaPath: '#/properties/engineMode/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema40.properties.engineMode.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.createdAt !== undefined) {
                                let data3 = data.createdAt;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats0.validate(data3)) {
                                                validate22.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdAt',
                                                        schemaPath: '#/properties/createdAt/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate22.errors = [
                                                {
                                                    instancePath: instancePath + '/createdAt',
                                                    schemaPath: '#/properties/createdAt/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.description !== undefined) {
                                    let data4 = data.description;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) > 1000) {
                                                validate22.errors = [
                                                    {
                                                        instancePath: instancePath + '/description',
                                                        schemaPath: '#/properties/description/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 1000 },
                                                        message: 'must NOT have more than 1000 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate22.errors = [
                                                {
                                                    instancePath: instancePath + '/description',
                                                    schemaPath: '#/properties/description/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.documentation !== undefined) {
                                        let data5 = data.documentation;
                                        const _errs11 = errors;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing1;
                                                if ((data5.lastModified === undefined && (missing1 = 'lastModified')) ||
                                                    (data5.content === undefined && (missing1 = 'content'))) {
                                                    validate22.errors = [
                                                        {
                                                            instancePath: instancePath + '/documentation',
                                                            schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5.lastModified !== undefined) {
                                                        let data6 = data5.lastModified;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (errors === _errs14) {
                                                                if (typeof data6 === 'string') {
                                                                    if (!formats0.validate(data6)) {
                                                                        validate22.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/documentation/lastModified',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/lastModified/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate22.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/documentation/lastModified',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/lastModified/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid3 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data5.content !== undefined) {
                                                            let data7 = data5.content;
                                                            const _errs16 = errors;
                                                            if (errors === _errs16) {
                                                                if (typeof data7 === 'string') {
                                                                    if (func2(data7) > 50000) {
                                                                        validate22.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/documentation/content',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/maxLength',
                                                                                keyword: 'maxLength',
                                                                                params: { limit: 50000 },
                                                                                message: 'must NOT have more than 50000 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (func2(data7) < 1) {
                                                                            validate22.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/documentation/content',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate22.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/documentation/content',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate22.errors = [
                                                    {
                                                        instancePath: instancePath + '/documentation',
                                                        schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.image !== undefined) {
                                            let data8 = data.image;
                                            const _errs18 = errors;
                                            if (errors === _errs18) {
                                                if (typeof data8 === 'string') {
                                                    if (func2(data8) > 1024) {
                                                        validate22.errors = [
                                                            {
                                                                instancePath: instancePath + '/image',
                                                                schemaPath: '#/properties/image/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 1024 },
                                                                message: 'must NOT have more than 1024 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate22.errors = [
                                                        {
                                                            instancePath: instancePath + '/image',
                                                            schemaPath: '#/properties/image/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs18 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.imageUrl !== undefined) {
                                                const _errs20 = errors;
                                                if (typeof data.imageUrl !== 'string') {
                                                    validate22.errors = [
                                                        {
                                                            instancePath: instancePath + '/imageUrl',
                                                            schemaPath: '#/properties/imageUrl/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs20 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.rowVersion !== undefined) {
                                                    let data10 = data.rowVersion;
                                                    const _errs22 = errors;
                                                    if (errors === _errs22) {
                                                        if (typeof data10 == 'number') {
                                                            if (data10 < 0 || isNaN(data10)) {
                                                                validate22.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/rowVersion',
                                                                        schemaPath: '#/properties/rowVersion/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate22.errors = [
                                                                {
                                                                    instancePath: instancePath + '/rowVersion',
                                                                    schemaPath: '#/properties/rowVersion/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs22 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.challengeData !== undefined) {
                                                        let data11 = data.challengeData;
                                                        const _errs24 = errors;
                                                        const _errs25 = errors;
                                                        if (errors === _errs25) {
                                                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                                let missing2;
                                                                if ((data11.challengeID === undefined && (missing2 = 'challengeID')) ||
                                                                    (data11.percentComplete === undefined && (missing2 = 'percentComplete'))) {
                                                                    validate22.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/challengeData',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing2 },
                                                                            message: "must have required property '" + missing2 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data11.challengeID !== undefined) {
                                                                        let data12 = data11.challengeID;
                                                                        const _errs27 = errors;
                                                                        if (errors === _errs27) {
                                                                            if (typeof data12 == 'number') {
                                                                                if (data12 < 1 || isNaN(data12)) {
                                                                                    validate22.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/challengeID',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/challengeID/minimum',
                                                                                            keyword: 'minimum',
                                                                                            params: { comparison: '>=', limit: 1 },
                                                                                            message: 'must be >= 1'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate22.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/challengeData/challengeID',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/challengeID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'number' },
                                                                                        message: 'must be number'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid5 = _errs27 === errors;
                                                                    }
                                                                    else {
                                                                        var valid5 = true;
                                                                    }
                                                                    if (valid5) {
                                                                        if (data11.userID !== undefined) {
                                                                            let data13 = data11.userID;
                                                                            const _errs29 = errors;
                                                                            if (errors === _errs29) {
                                                                                if (typeof data13 === 'string') {
                                                                                    if (func2(data13) > 128) {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/userID',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/maxLength',
                                                                                                keyword: 'maxLength',
                                                                                                params: { limit: 128 },
                                                                                                message: 'must NOT have more than 128 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (func2(data13) < 1) {
                                                                                            validate22.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/userID',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate22.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/userID',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid5 = _errs29 === errors;
                                                                        }
                                                                        else {
                                                                            var valid5 = true;
                                                                        }
                                                                        if (valid5) {
                                                                            if (data11.dataSourceID !== undefined) {
                                                                                let data14 = data11.dataSourceID;
                                                                                const _errs31 = errors;
                                                                                if (errors === _errs31) {
                                                                                    if (typeof data14 === 'string') {
                                                                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                                                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                                        if (func76(data14) < b64min1 || func76(data14) > b64max1) {
                                                                                            validate22.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: {
                                                                                                        error: 'encoded',
                                                                                                        b64min: b64min1,
                                                                                                        b64max: b64max1,
                                                                                                        length: func76(data14)
                                                                                                    },
                                                                                                    message: 'length must be between ' +
                                                                                                        b64min1 +
                                                                                                        ' and ' +
                                                                                                        b64max1 +
                                                                                                        ', but is ' +
                                                                                                        func76(data14)
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const decoded1 = func77(data14);
                                                                                            if (decoded1.length !== 9) {
                                                                                                validate22.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'decoded' },
                                                                                                        message: 'must decode to 9 bytes'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const encoded1 = func78(decoded1);
                                                                                                if (func79(encoded1) !== func79(data14)) {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'ambiguous' },
                                                                                                            message: 'encoding is ambiguous'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid5 = _errs31 === errors;
                                                                            }
                                                                            else {
                                                                                var valid5 = true;
                                                                            }
                                                                            if (valid5) {
                                                                                if (data11.originID !== undefined) {
                                                                                    let data15 = data11.originID;
                                                                                    const _errs33 = errors;
                                                                                    if (errors === _errs33) {
                                                                                        if (typeof data15 === 'string') {
                                                                                            const b64min2 = Math.ceil((4 * 9) / 3);
                                                                                            const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                                                            if (func80(data15) < b64min2 || func80(data15) > b64max2) {
                                                                                                validate22.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/challengeData/originID',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: {
                                                                                                            error: 'encoded',
                                                                                                            b64min: b64min2,
                                                                                                            b64max: b64max2,
                                                                                                            length: func80(data15)
                                                                                                        },
                                                                                                        message: 'length must be between ' +
                                                                                                            b64min2 +
                                                                                                            ' and ' +
                                                                                                            b64max2 +
                                                                                                            ', but is ' +
                                                                                                            func80(data15)
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const decoded2 = func81(data15);
                                                                                                if (decoded2.length !== 9) {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/originID',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'decoded' },
                                                                                                            message: 'must decode to 9 bytes'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    const encoded2 = func82(decoded2);
                                                                                                    if (func83(encoded2) !== func83(data15)) {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/originID',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: { error: 'ambiguous' },
                                                                                                                message: 'encoding is ambiguous'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate22.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/originID',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid5 = _errs33 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid5 = true;
                                                                                }
                                                                                if (valid5) {
                                                                                    if (data11.createdAt !== undefined) {
                                                                                        let data16 = data11.createdAt;
                                                                                        const _errs35 = errors;
                                                                                        if (errors === _errs35) {
                                                                                            if (errors === _errs35) {
                                                                                                if (typeof data16 === 'string') {
                                                                                                    if (!formats0.validate(data16)) {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/createdAt',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/createdAt/format',
                                                                                                                keyword: 'format',
                                                                                                                params: { format: 'date-time' },
                                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/createdAt',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/createdAt/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        var valid5 = _errs35 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid5 = true;
                                                                                    }
                                                                                    if (valid5) {
                                                                                        if (data11.lastUpdatedAt !== undefined) {
                                                                                            let data17 = data11.lastUpdatedAt;
                                                                                            const _errs37 = errors;
                                                                                            if (errors === _errs37) {
                                                                                                if (errors === _errs37) {
                                                                                                    if (typeof data17 === 'string') {
                                                                                                        if (!formats0.validate(data17)) {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/challengeData/lastUpdatedAt',
                                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/lastUpdatedAt/format',
                                                                                                                    keyword: 'format',
                                                                                                                    params: { format: 'date-time' },
                                                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/lastUpdatedAt',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/lastUpdatedAt/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            var valid5 = _errs37 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid5 = true;
                                                                                        }
                                                                                        if (valid5) {
                                                                                            if (data11.percentComplete !== undefined) {
                                                                                                let data18 = data11.percentComplete;
                                                                                                const _errs39 = errors;
                                                                                                if (errors === _errs39) {
                                                                                                    if (typeof data18 == 'number') {
                                                                                                        if (data18 > 100 || isNaN(data18)) {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/maximum',
                                                                                                                    keyword: 'maximum',
                                                                                                                    params: { comparison: '<=', limit: 100 },
                                                                                                                    message: 'must be <= 100'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            if (data18 < 0 || isNaN(data18)) {
                                                                                                                validate22.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/minimum',
                                                                                                                        keyword: 'minimum',
                                                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                                                        message: 'must be >= 0'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'number' },
                                                                                                                message: 'must be number'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid5 = _errs39 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid5 = true;
                                                                                            }
                                                                                            if (valid5) {
                                                                                                if (data11.state !== undefined) {
                                                                                                    let data19 = data11.state;
                                                                                                    const _errs41 = errors;
                                                                                                    if (typeof data19 !== 'string') {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/state',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/state/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    if (!(data19 === 'not_started' ||
                                                                                                        data19 === 'started' ||
                                                                                                        data19 === 'complete')) {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/state',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/state/enum',
                                                                                                                keyword: 'enum',
                                                                                                                params: { allowedValues: schema42.properties.state.enum },
                                                                                                                message: 'must be equal to one of the allowed values'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid5 = _errs41 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid5 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate22.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/challengeData',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs24 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.parentFolderID !== undefined) {
                                                            let data20 = data.parentFolderID;
                                                            const _errs43 = errors;
                                                            if (errors === _errs43) {
                                                                if (typeof data20 === 'string') {
                                                                    const b64min3 = Math.ceil((4 * 9) / 3);
                                                                    const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                    if (func84(data20) < b64min3 || func84(data20) > b64max3) {
                                                                        validate22.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/parentFolderID',
                                                                                schemaPath: '#/properties/parentFolderID/uid',
                                                                                keyword: 'uid',
                                                                                params: {
                                                                                    error: 'encoded',
                                                                                    b64min: b64min3,
                                                                                    b64max: b64max3,
                                                                                    length: func84(data20)
                                                                                },
                                                                                message: 'length must be between ' +
                                                                                    b64min3 +
                                                                                    ' and ' +
                                                                                    b64max3 +
                                                                                    ', but is ' +
                                                                                    func84(data20)
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const decoded3 = func85(data20);
                                                                        if (decoded3.length !== 9) {
                                                                            validate22.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/parentFolderID',
                                                                                    schemaPath: '#/properties/parentFolderID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'decoded' },
                                                                                    message: 'must decode to 9 bytes'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const encoded3 = func86(decoded3);
                                                                            if (func87(encoded3) !== func87(data20)) {
                                                                                validate22.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parentFolderID',
                                                                                        schemaPath: '#/properties/parentFolderID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'ambiguous' },
                                                                                        message: 'encoding is ambiguous'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate22.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/parentFolderID',
                                                                            schemaPath: '#/properties/parentFolderID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs43 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.isEditor !== undefined) {
                                                                const _errs45 = errors;
                                                                if (typeof data.isEditor !== 'boolean') {
                                                                    validate22.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/isEditor',
                                                                            schemaPath: '#/properties/isEditor/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'boolean' },
                                                                            message: 'must be boolean'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs45 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.isPublic !== undefined) {
                                                                    const _errs47 = errors;
                                                                    if (typeof data.isPublic !== 'boolean') {
                                                                        validate22.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/isPublic',
                                                                                schemaPath: '#/properties/isPublic/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'boolean' },
                                                                                message: 'must be boolean'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid0 = _errs47 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
const func88 = ucs2length;
const func89 = base64urlToBuffer;
const func90 = base64urlEncode;
const func91 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func92 = ucs2length;
const func93 = base64urlToBuffer;
const func94 = base64urlEncode;
const func95 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:BlueprintResponse" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipe === undefined && (missing0 = 'pipe')) ||
                (data.originIDs === undefined && (missing0 = 'originIDs')) ||
                (data.visualizationIDs === undefined && (missing0 = 'visualizationIDs'))) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipe !== undefined) {
                    const _errs1 = errors;
                    if (!validate22(data.pipe, {
                        instancePath: instancePath + '/pipe',
                        parentData: data,
                        parentDataProperty: 'pipe',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.originIDs !== undefined) {
                        let data1 = data.originIDs;
                        const _errs2 = errors;
                        if (errors === _errs2) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data2 === 'string') {
                                            const b64min0 = Math.ceil((4 * 9) / 3);
                                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                            if (func88(data2) < b64min0 || func88(data2) > b64max0) {
                                                validate21.errors = [
                                                    {
                                                        instancePath: instancePath + '/originIDs/' + i0,
                                                        schemaPath: '#/properties/originIDs/items/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func88(data2) },
                                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func88(data2)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded0 = func89(data2);
                                                if (decoded0.length !== 9) {
                                                    validate21.errors = [
                                                        {
                                                            instancePath: instancePath + '/originIDs/' + i0,
                                                            schemaPath: '#/properties/originIDs/items/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 9 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded0 = func90(decoded0);
                                                    if (func91(encoded0) !== func91(data2)) {
                                                        validate21.errors = [
                                                            {
                                                                instancePath: instancePath + '/originIDs/' + i0,
                                                                schemaPath: '#/properties/originIDs/items/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/originIDs/' + i0,
                                                    schemaPath: '#/properties/originIDs/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs4 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/originIDs',
                                        schemaPath: '#/properties/originIDs/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.visualizationIDs !== undefined) {
                            let data3 = data.visualizationIDs;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (Array.isArray(data3)) {
                                    var valid3 = true;
                                    const len1 = data3.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                        let data4 = data3[i1];
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (typeof data4 === 'string') {
                                                const b64min1 = Math.ceil((4 * 9) / 3);
                                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func92(data4) < b64min1 || func92(data4) > b64max1) {
                                                    validate21.errors = [
                                                        {
                                                            instancePath: instancePath + '/visualizationIDs/' + i1,
                                                            schemaPath: '#/properties/visualizationIDs/items/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func92(data4) },
                                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func92(data4)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded1 = func93(data4);
                                                    if (decoded1.length !== 9) {
                                                        validate21.errors = [
                                                            {
                                                                instancePath: instancePath + '/visualizationIDs/' + i1,
                                                                schemaPath: '#/properties/visualizationIDs/items/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded1 = func94(decoded1);
                                                        if (func95(encoded1) !== func95(data4)) {
                                                            validate21.errors = [
                                                                {
                                                                    instancePath: instancePath + '/visualizationIDs/' + i1,
                                                                    schemaPath: '#/properties/visualizationIDs/items/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate21.errors = [
                                                    {
                                                        instancePath: instancePath + '/visualizationIDs/' + i1,
                                                        schemaPath: '#/properties/visualizationIDs/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid3 = _errs8 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/visualizationIDs',
                                            schemaPath: '#/properties/visualizationIDs/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs6 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const challengeDataSchemaValidation = validate24;
const func98 = ucs2length;
const func99 = base64urlToBuffer;
const func100 = base64urlEncode;
const func101 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func102 = ucs2length;
const func103 = base64urlToBuffer;
const func104 = base64urlEncode;
const func105 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ChallengeData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.challengeID === undefined && (missing0 = 'challengeID')) ||
                (data.percentComplete === undefined && (missing0 = 'percentComplete'))) {
                validate24.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.challengeID !== undefined) {
                    let data0 = data.challengeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 1 || isNaN(data0)) {
                                validate24.errors = [
                                    {
                                        instancePath: instancePath + '/challengeID',
                                        schemaPath: '#/properties/challengeID/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 1 },
                                        message: 'must be >= 1'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate24.errors = [
                                {
                                    instancePath: instancePath + '/challengeID',
                                    schemaPath: '#/properties/challengeID/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 128) {
                                    validate24.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 128 },
                                            message: 'must NOT have more than 128 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate24.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.dataSourceID !== undefined) {
                            let data2 = data.dataSourceID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func98(data2) < b64min0 || func98(data2) > b64max0) {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func98(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func98(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func99(data2);
                                        if (decoded0.length !== 9) {
                                            validate24.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func100(decoded0);
                                            if (func101(encoded0) !== func101(data2)) {
                                                validate24.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate24.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.originID !== undefined) {
                                let data3 = data.originID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func102(data3) < b64min1 || func102(data3) > b64max1) {
                                            validate24.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func102(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func102(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func103(data3);
                                            if (decoded1.length !== 9) {
                                                validate24.errors = [
                                                    {
                                                        instancePath: instancePath + '/originID',
                                                        schemaPath: '#/properties/originID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func104(decoded1);
                                                if (func105(encoded1) !== func105(data3)) {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath + '/originID',
                                                            schemaPath: '#/properties/originID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.createdAt !== undefined) {
                                    let data4 = data.createdAt;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate24.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdAt',
                                                        schemaPath: '#/properties/createdAt/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.lastUpdatedAt !== undefined) {
                                        let data5 = data.lastUpdatedAt;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats0.validate(data5)) {
                                                        validate24.errors = [
                                                            {
                                                                instancePath: instancePath + '/lastUpdatedAt',
                                                                schemaPath: '#/properties/lastUpdatedAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath + '/lastUpdatedAt',
                                                            schemaPath: '#/properties/lastUpdatedAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.percentComplete !== undefined) {
                                            let data6 = data.percentComplete;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 == 'number') {
                                                    if (data6 > 100 || isNaN(data6)) {
                                                        validate24.errors = [
                                                            {
                                                                instancePath: instancePath + '/percentComplete',
                                                                schemaPath: '#/properties/percentComplete/maximum',
                                                                keyword: 'maximum',
                                                                params: { comparison: '<=', limit: 100 },
                                                                message: 'must be <= 100'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data6 < 0 || isNaN(data6)) {
                                                            validate24.errors = [
                                                                {
                                                                    instancePath: instancePath + '/percentComplete',
                                                                    schemaPath: '#/properties/percentComplete/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: 0 },
                                                                    message: 'must be >= 0'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath + '/percentComplete',
                                                            schemaPath: '#/properties/percentComplete/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.state !== undefined) {
                                                let data7 = data.state;
                                                const _errs15 = errors;
                                                if (typeof data7 !== 'string') {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath + '/state',
                                                            schemaPath: '#/properties/state/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data7 === 'not_started' || data7 === 'started' || data7 === 'complete')) {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath + '/state',
                                                            schemaPath: '#/properties/state/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema42.properties.state.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate24.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
export const churnParamsSchemaValidation = validate25;
const schema44 = {
    $id: 'urn:wisepipe-solution-domain:ChurnParams',
    type: 'object',
    properties: { churnColumn: { type: 'string', minLength: 1 }, churnValue: { type: 'string' } },
    required: []
};
function validate25(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:ChurnParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.churnColumn !== undefined) {
                let data0 = data.churnColumn;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate25.errors = [
                                {
                                    instancePath: instancePath + '/churnColumn',
                                    schemaPath: '#/properties/churnColumn/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate25.errors = [
                            {
                                instancePath: instancePath + '/churnColumn',
                                schemaPath: '#/properties/churnColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.churnValue !== undefined) {
                    const _errs3 = errors;
                    if (typeof data.churnValue !== 'string') {
                        validate25.errors = [
                            {
                                instancePath: instancePath + '/churnValue',
                                schemaPath: '#/properties/churnValue/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate25.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate25.errors = vErrors;
    return errors === 0;
}
export const columnSchemaValidation = validate26;
const schema45 = {
    $id: 'urn:wisepipe-common-data:Column',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        type: { type: 'string', pattern: 'number|date|string|boolean|decimal|period' },
        metadata: {
            type: 'object',
            oneOf: [
                {
                    if: { properties: { type: { const: 'period' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' }
                },
                {
                    if: { properties: { type: { const: 'string' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' }
                }
            ]
        },
        isPrimaryKey: { type: 'boolean' }
    },
    required: ['name', 'type'],
    allOf: [
        {
            if: { properties: { type: { const: 'period' } } },
            then: {
                required: ['metadata'],
                properties: { metadata: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' } }
            }
        },
        {
            if: { properties: { type: { const: 'string' } } },
            then: { properties: { metadata: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' } } }
        },
        {
            if: { properties: { type: { enum: ['boolean', 'number', 'decimal', 'date'] } } },
            then: { not: { required: ['metadata'] } }
        }
    ]
};
const schema46 = {
    $id: 'urn:wisepipe-common-data:PeriodColumnMetadata',
    type: 'object',
    properties: { calendarID: { type: 'string', minLength: 1 }, level: { type: 'string', minLength: 1 } },
    required: ['calendarID', 'level']
};
const schema47 = {
    $id: 'urn:wisepipe-common-data:PicklistColumnMetadata',
    type: 'object',
    properties: { table: { type: 'string', minLength: 1 }, column: { type: 'string', minLength: 1 } },
    required: ['table', 'column']
};
const pattern0 = new RegExp('number|date|string|boolean|decimal|period', 'u');
function validate26(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:Column" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('period' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.metadata === undefined && (missing0 = 'metadata')) {
                validate26.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.metadata !== undefined) {
                    let data1 = data.metadata;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                            let missing1;
                            if ((data1.calendarID === undefined && (missing1 = 'calendarID')) ||
                                (data1.level === undefined && (missing1 = 'level'))) {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1.calendarID !== undefined) {
                                    let data2 = data1.calendarID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) < 1) {
                                                validate26.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/calendarID',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/calendarID',
                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid5 = _errs9 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                                if (valid5) {
                                    if (data1.level !== undefined) {
                                        let data3 = data1.level;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data3 === 'string') {
                                                if (func2(data3) < 1) {
                                                    validate26.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/level',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate26.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/level',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs11 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate26.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate26.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs13 = errors;
        const _errs14 = errors;
        let valid6 = true;
        const _errs15 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('string' !== data.type) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs15 === errors;
        errors = _errs14;
        if (vErrors !== null) {
            if (_errs14) {
                vErrors.length = _errs14;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs17 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.metadata !== undefined) {
                    let data5 = data.metadata;
                    const _errs19 = errors;
                    if (errors === _errs19) {
                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                            let missing2;
                            if ((data5.table === undefined && (missing2 = 'table')) ||
                                (data5.column === undefined && (missing2 = 'column'))) {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing2 },
                                        message: "must have required property '" + missing2 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data5.table !== undefined) {
                                    let data6 = data5.table;
                                    const _errs21 = errors;
                                    if (errors === _errs21) {
                                        if (typeof data6 === 'string') {
                                            if (func2(data6) < 1) {
                                                validate26.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/table',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/table',
                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs21 === errors;
                                }
                                else {
                                    var valid10 = true;
                                }
                                if (valid10) {
                                    if (data5.column !== undefined) {
                                        let data7 = data5.column;
                                        const _errs23 = errors;
                                        if (errors === _errs23) {
                                            if (typeof data7 === 'string') {
                                                if (func2(data7) < 1) {
                                                    validate26.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/column',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate26.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/column',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs23 === errors;
                                    }
                                    else {
                                        var valid10 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate26.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
            var _valid1 = _errs17 === errors;
            valid6 = _valid1;
        }
        if (!valid6) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate26.errors = vErrors;
            return false;
        }
        var valid0 = _errs13 === errors;
        if (valid0) {
            const _errs25 = errors;
            const _errs26 = errors;
            let valid11 = true;
            const _errs27 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    let data8 = data.type;
                    if (!(data8 === 'boolean' || data8 === 'number' || data8 === 'decimal' || data8 === 'date')) {
                        const err4 = {};
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs27 === errors;
            errors = _errs26;
            if (vErrors !== null) {
                if (_errs26) {
                    vErrors.length = _errs26;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs29 = errors;
                const _errs30 = errors;
                const _errs31 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing3;
                    if (data.metadata === undefined && (missing3 = 'metadata')) {
                        const err5 = {};
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                }
                var valid13 = _errs31 === errors;
                if (valid13) {
                    validate26.errors = [
                        { instancePath, schemaPath: '#/allOf/2/then/not', keyword: 'not', params: {}, message: 'must NOT be valid' }
                    ];
                    return false;
                }
                else {
                    errors = _errs30;
                    if (vErrors !== null) {
                        if (_errs30) {
                            vErrors.length = _errs30;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                }
                var _valid2 = _errs29 === errors;
                valid11 = _valid2;
            }
            if (!valid11) {
                const err6 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
                validate26.errors = vErrors;
                return false;
            }
            var valid0 = _errs25 === errors;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.name === undefined && (missing4 = 'name')) || (data.type === undefined && (missing4 = 'type'))) {
                validate26.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data9 = data.name;
                    const _errs32 = errors;
                    if (errors === _errs32) {
                        if (typeof data9 === 'string') {
                            if (func2(data9) > 150) {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data9) < 1) {
                                    validate26.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate26.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid14 = _errs32 === errors;
                }
                else {
                    var valid14 = true;
                }
                if (valid14) {
                    if (data.type !== undefined) {
                        let data10 = data.type;
                        const _errs34 = errors;
                        if (errors === _errs34) {
                            if (typeof data10 === 'string') {
                                if (!pattern0.test(data10)) {
                                    validate26.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: 'number|date|string|boolean|decimal|period' },
                                            message: 'must match pattern "' + 'number|date|string|boolean|decimal|period' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid14 = _errs34 === errors;
                    }
                    else {
                        var valid14 = true;
                    }
                    if (valid14) {
                        if (data.metadata !== undefined) {
                            let data11 = data.metadata;
                            const _errs36 = errors;
                            if (!(data11 && typeof data11 == 'object' && !Array.isArray(data11))) {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: '#/properties/metadata/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                            const _errs38 = errors;
                            let valid15 = false;
                            let passing0 = null;
                            const _errs39 = errors;
                            const _errs40 = errors;
                            let valid16 = true;
                            const _errs41 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('period' !== data11.type) {
                                        const err7 = {};
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid4 = _errs41 === errors;
                            errors = _errs40;
                            if (vErrors !== null) {
                                if (_errs40) {
                                    vErrors.length = _errs40;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid4) {
                                const _errs43 = errors;
                                const _errs44 = errors;
                                if (errors === _errs44) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing5;
                                        if ((data11.calendarID === undefined && (missing5 = 'calendarID')) ||
                                            (data11.level === undefined && (missing5 = 'level'))) {
                                            const err8 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing5 },
                                                message: "must have required property '" + missing5 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            }
                                            else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.calendarID !== undefined) {
                                                let data13 = data11.calendarID;
                                                const _errs46 = errors;
                                                if (errors === _errs46) {
                                                    if (typeof data13 === 'string') {
                                                        if (func2(data13) < 1) {
                                                            const err9 = {
                                                                instancePath: instancePath + '/metadata/calendarID',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err9];
                                                            }
                                                            else {
                                                                vErrors.push(err9);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err10 = {
                                                            instancePath: instancePath + '/metadata/calendarID',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err10];
                                                        }
                                                        else {
                                                            vErrors.push(err10);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid19 = _errs46 === errors;
                                            }
                                            else {
                                                var valid19 = true;
                                            }
                                            if (valid19) {
                                                if (data11.level !== undefined) {
                                                    let data14 = data11.level;
                                                    const _errs48 = errors;
                                                    if (errors === _errs48) {
                                                        if (typeof data14 === 'string') {
                                                            if (func2(data14) < 1) {
                                                                const err11 = {
                                                                    instancePath: instancePath + '/metadata/level',
                                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err11];
                                                                }
                                                                else {
                                                                    vErrors.push(err11);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err12 = {
                                                                instancePath: instancePath + '/metadata/level',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err12];
                                                            }
                                                            else {
                                                                vErrors.push(err12);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid19 = _errs48 === errors;
                                                }
                                                else {
                                                    var valid19 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err13 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid4 = _errs43 === errors;
                                valid16 = _valid4;
                            }
                            if (!valid16) {
                                const err14 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/0/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                            var _valid3 = _errs39 === errors;
                            if (_valid3) {
                                valid15 = true;
                                passing0 = 0;
                            }
                            const _errs50 = errors;
                            const _errs51 = errors;
                            let valid20 = true;
                            const _errs52 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('string' !== data11.type) {
                                        const err15 = {};
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid5 = _errs52 === errors;
                            errors = _errs51;
                            if (vErrors !== null) {
                                if (_errs51) {
                                    vErrors.length = _errs51;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid5) {
                                const _errs54 = errors;
                                const _errs55 = errors;
                                if (errors === _errs55) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing6;
                                        if ((data11.table === undefined && (missing6 = 'table')) ||
                                            (data11.column === undefined && (missing6 = 'column'))) {
                                            const err16 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing6 },
                                                message: "must have required property '" + missing6 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err16];
                                            }
                                            else {
                                                vErrors.push(err16);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.table !== undefined) {
                                                let data16 = data11.table;
                                                const _errs57 = errors;
                                                if (errors === _errs57) {
                                                    if (typeof data16 === 'string') {
                                                        if (func2(data16) < 1) {
                                                            const err17 = {
                                                                instancePath: instancePath + '/metadata/table',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err17];
                                                            }
                                                            else {
                                                                vErrors.push(err17);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err18 = {
                                                            instancePath: instancePath + '/metadata/table',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err18];
                                                        }
                                                        else {
                                                            vErrors.push(err18);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid23 = _errs57 === errors;
                                            }
                                            else {
                                                var valid23 = true;
                                            }
                                            if (valid23) {
                                                if (data11.column !== undefined) {
                                                    let data17 = data11.column;
                                                    const _errs59 = errors;
                                                    if (errors === _errs59) {
                                                        if (typeof data17 === 'string') {
                                                            if (func2(data17) < 1) {
                                                                const err19 = {
                                                                    instancePath: instancePath + '/metadata/column',
                                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err19];
                                                                }
                                                                else {
                                                                    vErrors.push(err19);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err20 = {
                                                                instancePath: instancePath + '/metadata/column',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err20];
                                                            }
                                                            else {
                                                                vErrors.push(err20);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid23 = _errs59 === errors;
                                                }
                                                else {
                                                    var valid23 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err21 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err21];
                                        }
                                        else {
                                            vErrors.push(err21);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid5 = _errs54 === errors;
                                valid20 = _valid5;
                            }
                            if (!valid20) {
                                const err22 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/1/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                            var _valid3 = _errs50 === errors;
                            if (_valid3 && valid15) {
                                valid15 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid15 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid15) {
                                const err23 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                                validate26.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs38;
                                if (vErrors !== null) {
                                    if (_errs38) {
                                        vErrors.length = _errs38;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid14 = _errs36 === errors;
                        }
                        else {
                            var valid14 = true;
                        }
                        if (valid14) {
                            if (data.isPrimaryKey !== undefined) {
                                const _errs61 = errors;
                                if (typeof data.isPrimaryKey !== 'boolean') {
                                    validate26.errors = [
                                        {
                                            instancePath: instancePath + '/isPrimaryKey',
                                            schemaPath: '#/properties/isPrimaryKey/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid14 = _errs61 === errors;
                            }
                            else {
                                var valid14 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate26.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate26.errors = vErrors;
    return errors === 0;
}
export const dataEventInputSchemaValidation = validate27;
const schema50 = {
    $id: 'urn:wisepipe-solution-domain:DataEventInput',
    type: 'object',
    properties: { task: { $ref: 'urn:wisepipe-solution-domain:MatchTask' } },
    required: []
};
const schema51 = {
    $id: 'urn:wisepipe-solution-domain:MatchTask',
    type: 'object',
    properties: {
        taskID: { type: 'string', minLength: 1 },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        dataSourceID: { type: 'string', uid: 9 }
    },
    required: ['taskID', 'orgID', 'dataSourceID']
};
const func118 = ucs2length;
const func119 = base64urlToBuffer;
const func120 = base64urlEncode;
const func121 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const formats16 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:DataEventInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.task !== undefined) {
                let data0 = data.task;
                const _errs2 = errors;
                if (errors === _errs2) {
                    if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                        let missing0;
                        if ((data0.taskID === undefined && (missing0 = 'taskID')) ||
                            (data0.orgID === undefined && (missing0 = 'orgID')) ||
                            (data0.dataSourceID === undefined && (missing0 = 'dataSourceID'))) {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/task',
                                    schemaPath: 'urn:wisepipe-solution-domain:MatchTask/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing0 },
                                    message: "must have required property '" + missing0 + "'"
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0.taskID !== undefined) {
                                let data1 = data0.taskID;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (typeof data1 === 'string') {
                                        if (func2(data1) < 1) {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/task/taskID',
                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/taskID/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/task/taskID',
                                                schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/taskID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs4 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data0.orgID !== undefined) {
                                    let data2 = data0.orgID;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (!formats16.test(data2)) {
                                                    validate27.errors = [
                                                        {
                                                            instancePath: instancePath + '/task/orgID',
                                                            schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/orgID/format',
                                                            keyword: 'format',
                                                            params: { format: 'uuid' },
                                                            message: 'must match format "' + 'uuid' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate27.errors = [
                                                    {
                                                        instancePath: instancePath + '/task/orgID',
                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/orgID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid2 = _errs6 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.orgPlan !== undefined) {
                                        let data3 = data0.orgPlan;
                                        const _errs8 = errors;
                                        if (typeof data3 !== 'string') {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/task/orgPlan',
                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/orgPlan/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data3 === 'Social' ||
                                            data3 === 'Enterprise' ||
                                            data3 === 'Integration' ||
                                            data3 === 'Temp' ||
                                            data3 === 'Starter' ||
                                            data3 === 'Professional')) {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/task/orgPlan',
                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/orgPlan/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema51.properties.orgPlan.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs8 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.dataSourceID !== undefined) {
                                            let data4 = data0.dataSourceID;
                                            const _errs10 = errors;
                                            if (errors === _errs10) {
                                                if (typeof data4 === 'string') {
                                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func118(data4) < b64min0 || func118(data4) > b64max0) {
                                                        validate27.errors = [
                                                            {
                                                                instancePath: instancePath + '/task/dataSourceID',
                                                                schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/dataSourceID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func118(data4) },
                                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func118(data4)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded0 = func119(data4);
                                                        if (decoded0.length !== 9) {
                                                            validate27.errors = [
                                                                {
                                                                    instancePath: instancePath + '/task/dataSourceID',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/dataSourceID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded0 = func120(decoded0);
                                                            if (func121(encoded0) !== func121(data4)) {
                                                                validate27.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/task/dataSourceID',
                                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/dataSourceID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate27.errors = [
                                                        {
                                                            instancePath: instancePath + '/task/dataSourceID',
                                                            schemaPath: 'urn:wisepipe-solution-domain:MatchTask/properties/dataSourceID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs10 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        validate27.errors = [
                            {
                                instancePath: instancePath + '/task',
                                schemaPath: 'urn:wisepipe-solution-domain:MatchTask/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const dataSchemaValidation = validate28;
const schema52 = {
    $id: 'urn:wisepipe-base-computation:Data',
    type: 'object',
    properties: {
        status: { type: 'string', enum: ['running', 'completed', 'failed'] },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' } },
        rows: { type: 'array', items: { type: 'array', items: { type: ['boolean', 'string', 'number', 'null'] } } },
        continuationToken: { type: 'string', uid: 9 },
        schema: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' } },
        maxNumBins: { type: 'number' },
        metrics: { type: 'array', items: { type: 'object' } }
    },
    required: ['status', 'progress'],
    if: { properties: { progress: { type: 'number', exclusiveMaximum: 1 } } },
    then: { required: ['continuationToken'] }
};
const func122 = ucs2length;
const func123 = base64urlToBuffer;
const func124 = base64urlEncode;
const func125 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-computation:Data" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.progress !== undefined) {
            let data0 = data.progress;
            const _errs3 = errors;
            if (errors === _errs3) {
                if (typeof data0 == 'number') {
                    if (data0 >= 1 || isNaN(data0)) {
                        const err0 = {};
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                }
                else {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.continuationToken === undefined && (missing0 = 'continuationToken')) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate28.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.status === undefined && (missing1 = 'status')) ||
                (data.progress === undefined && (missing1 = 'progress'))) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.status !== undefined) {
                    let data1 = data.status;
                    const _errs6 = errors;
                    if (typeof data1 !== 'string') {
                        validate28.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'running' || data1 === 'completed' || data1 === 'failed')) {
                        validate28.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema52.properties.status.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.progress !== undefined) {
                        let data2 = data.progress;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (typeof data2 == 'number') {
                                if (data2 > 1 || isNaN(data2)) {
                                    validate28.errors = [
                                        {
                                            instancePath: instancePath + '/progress',
                                            schemaPath: '#/properties/progress/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 1 },
                                            message: 'must be <= 1'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate28.errors = [
                                            {
                                                instancePath: instancePath + '/progress',
                                                schemaPath: '#/properties/progress/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/progress',
                                        schemaPath: '#/properties/progress/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs8 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.columns !== undefined) {
                            let data3 = data.columns;
                            const _errs10 = errors;
                            if (errors === _errs10) {
                                if (Array.isArray(data3)) {
                                    var valid3 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs12 = errors;
                                        if (!validate26(data3[i0], {
                                            instancePath: instancePath + '/columns/' + i0,
                                            parentData: data3,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid3 = _errs12 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate28.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs10 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.rows !== undefined) {
                                let data5 = data.rows;
                                const _errs13 = errors;
                                if (errors === _errs13) {
                                    if (Array.isArray(data5)) {
                                        var valid4 = true;
                                        const len1 = data5.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                            let data6 = data5[i1];
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (Array.isArray(data6)) {
                                                    var valid5 = true;
                                                    const len2 = data6.length;
                                                    for (let i2 = 0; i2 < len2; i2++) {
                                                        let data7 = data6[i2];
                                                        const _errs17 = errors;
                                                        if (typeof data7 !== 'boolean' &&
                                                            typeof data7 !== 'string' &&
                                                            !(typeof data7 == 'number') &&
                                                            data7 !== null) {
                                                            validate28.errors = [
                                                                {
                                                                    instancePath: instancePath + '/rows/' + i1 + '/' + i2,
                                                                    schemaPath: '#/properties/rows/items/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: schema52.properties.rows.items.items.type },
                                                                    message: 'must be boolean,string,number,null'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid5 = _errs17 === errors;
                                                        if (!valid5) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate28.errors = [
                                                        {
                                                            instancePath: instancePath + '/rows/' + i1,
                                                            schemaPath: '#/properties/rows/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid4 = _errs15 === errors;
                                            if (!valid4) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate28.errors = [
                                            {
                                                instancePath: instancePath + '/rows',
                                                schemaPath: '#/properties/rows/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.continuationToken !== undefined) {
                                    let data8 = data.continuationToken;
                                    const _errs19 = errors;
                                    if (errors === _errs19) {
                                        if (typeof data8 === 'string') {
                                            const b64min0 = Math.ceil((4 * 9) / 3);
                                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                            if (func122(data8) < b64min0 || func122(data8) > b64max0) {
                                                validate28.errors = [
                                                    {
                                                        instancePath: instancePath + '/continuationToken',
                                                        schemaPath: '#/properties/continuationToken/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func122(data8) },
                                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func122(data8)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded0 = func123(data8);
                                                if (decoded0.length !== 9) {
                                                    validate28.errors = [
                                                        {
                                                            instancePath: instancePath + '/continuationToken',
                                                            schemaPath: '#/properties/continuationToken/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 9 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded0 = func124(decoded0);
                                                    if (func125(encoded0) !== func125(data8)) {
                                                        validate28.errors = [
                                                            {
                                                                instancePath: instancePath + '/continuationToken',
                                                                schemaPath: '#/properties/continuationToken/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate28.errors = [
                                                {
                                                    instancePath: instancePath + '/continuationToken',
                                                    schemaPath: '#/properties/continuationToken/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs19 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.schema !== undefined) {
                                        let data9 = data.schema;
                                        const _errs21 = errors;
                                        if (errors === _errs21) {
                                            if (Array.isArray(data9)) {
                                                var valid7 = true;
                                                const len3 = data9.length;
                                                for (let i3 = 0; i3 < len3; i3++) {
                                                    const _errs23 = errors;
                                                    if (!validate26(data9[i3], {
                                                        instancePath: instancePath + '/schema/' + i3,
                                                        parentData: data9,
                                                        parentDataProperty: i3,
                                                        rootData
                                                    })) {
                                                        vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
                                                        errors = vErrors.length;
                                                    }
                                                    var valid7 = _errs23 === errors;
                                                    if (!valid7) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate28.errors = [
                                                    {
                                                        instancePath: instancePath + '/schema',
                                                        schemaPath: '#/properties/schema/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs21 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.maxNumBins !== undefined) {
                                            const _errs24 = errors;
                                            if (!(typeof data.maxNumBins == 'number')) {
                                                validate28.errors = [
                                                    {
                                                        instancePath: instancePath + '/maxNumBins',
                                                        schemaPath: '#/properties/maxNumBins/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs24 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data.metrics !== undefined) {
                                                let data12 = data.metrics;
                                                const _errs26 = errors;
                                                if (errors === _errs26) {
                                                    if (Array.isArray(data12)) {
                                                        var valid8 = true;
                                                        const len4 = data12.length;
                                                        for (let i4 = 0; i4 < len4; i4++) {
                                                            let data13 = data12[i4];
                                                            const _errs28 = errors;
                                                            if (!(data13 && typeof data13 == 'object' && !Array.isArray(data13))) {
                                                                validate28.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/metrics/' + i4,
                                                                        schemaPath: '#/properties/metrics/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid8 = _errs28 === errors;
                                                            if (!valid8) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate28.errors = [
                                                            {
                                                                instancePath: instancePath + '/metrics',
                                                                schemaPath: '#/properties/metrics/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs26 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate28.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const diversityParamsSchemaValidation = validate31;
const schema53 = {
    $id: 'urn:wisepipe-solution-domain:DiversityParams',
    type: 'object',
    properties: {
        raceColumn: { type: 'string', minLength: 1 },
        genderColumn: { type: 'string', minLength: 1 },
        maleValue: { type: 'string', minLength: 1 },
        femaleValue: { type: 'string', minLength: 1 },
        positionColumn: { type: 'string', minLength: 1 },
        dateHiredColumn: { type: 'string', minLength: 1 },
        dateLeftColumn: { type: 'string', minLength: 1 },
        employeeSeniorityColumn: { type: 'string', minLength: 1 },
        employeeExecutiveValue: { type: 'string', minLength: 1 },
        hiringDataSourceID: { type: 'string', minLength: 1 },
        hiringRaceColumn: { type: 'string', minLength: 1 },
        hiringPositionColumn: { type: 'string', minLength: 1 },
        hiringDateColumn: { type: 'string', minLength: 1 },
        hiringSeniorityColumn: { type: 'string', minLength: 1 },
        hiringExecutiveValue: { type: 'string', minLength: 1 },
        hiringHiredColumn: { type: 'string', minLength: 1 },
        hiredValue: { type: 'string', minLength: 1 }
    },
    required: []
};
function validate31(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:DiversityParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.raceColumn !== undefined) {
                let data0 = data.raceColumn;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/raceColumn',
                                    schemaPath: '#/properties/raceColumn/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate31.errors = [
                            {
                                instancePath: instancePath + '/raceColumn',
                                schemaPath: '#/properties/raceColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.genderColumn !== undefined) {
                    let data1 = data.genderColumn;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/genderColumn',
                                        schemaPath: '#/properties/genderColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/genderColumn',
                                    schemaPath: '#/properties/genderColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.maleValue !== undefined) {
                        let data2 = data.maleValue;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate31.errors = [
                                        {
                                            instancePath: instancePath + '/maleValue',
                                            schemaPath: '#/properties/maleValue/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/maleValue',
                                        schemaPath: '#/properties/maleValue/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.femaleValue !== undefined) {
                            let data3 = data.femaleValue;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate31.errors = [
                                            {
                                                instancePath: instancePath + '/femaleValue',
                                                schemaPath: '#/properties/femaleValue/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate31.errors = [
                                        {
                                            instancePath: instancePath + '/femaleValue',
                                            schemaPath: '#/properties/femaleValue/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.positionColumn !== undefined) {
                                let data4 = data.positionColumn;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate31.errors = [
                                                {
                                                    instancePath: instancePath + '/positionColumn',
                                                    schemaPath: '#/properties/positionColumn/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate31.errors = [
                                            {
                                                instancePath: instancePath + '/positionColumn',
                                                schemaPath: '#/properties/positionColumn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.dateHiredColumn !== undefined) {
                                    let data5 = data.dateHiredColumn;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate31.errors = [
                                                    {
                                                        instancePath: instancePath + '/dateHiredColumn',
                                                        schemaPath: '#/properties/dateHiredColumn/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate31.errors = [
                                                {
                                                    instancePath: instancePath + '/dateHiredColumn',
                                                    schemaPath: '#/properties/dateHiredColumn/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.dateLeftColumn !== undefined) {
                                        let data6 = data.dateLeftColumn;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data6 === 'string') {
                                                if (func2(data6) < 1) {
                                                    validate31.errors = [
                                                        {
                                                            instancePath: instancePath + '/dateLeftColumn',
                                                            schemaPath: '#/properties/dateLeftColumn/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate31.errors = [
                                                    {
                                                        instancePath: instancePath + '/dateLeftColumn',
                                                        schemaPath: '#/properties/dateLeftColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.employeeSeniorityColumn !== undefined) {
                                            let data7 = data.employeeSeniorityColumn;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data7 === 'string') {
                                                    if (func2(data7) < 1) {
                                                        validate31.errors = [
                                                            {
                                                                instancePath: instancePath + '/employeeSeniorityColumn',
                                                                schemaPath: '#/properties/employeeSeniorityColumn/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate31.errors = [
                                                        {
                                                            instancePath: instancePath + '/employeeSeniorityColumn',
                                                            schemaPath: '#/properties/employeeSeniorityColumn/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.employeeExecutiveValue !== undefined) {
                                                let data8 = data.employeeExecutiveValue;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (typeof data8 === 'string') {
                                                        if (func2(data8) < 1) {
                                                            validate31.errors = [
                                                                {
                                                                    instancePath: instancePath + '/employeeExecutiveValue',
                                                                    schemaPath: '#/properties/employeeExecutiveValue/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate31.errors = [
                                                            {
                                                                instancePath: instancePath + '/employeeExecutiveValue',
                                                                schemaPath: '#/properties/employeeExecutiveValue/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.hiringDataSourceID !== undefined) {
                                                    let data9 = data.hiringDataSourceID;
                                                    const _errs19 = errors;
                                                    if (errors === _errs19) {
                                                        if (typeof data9 === 'string') {
                                                            if (func2(data9) < 1) {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hiringDataSourceID',
                                                                        schemaPath: '#/properties/hiringDataSourceID/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate31.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hiringDataSourceID',
                                                                    schemaPath: '#/properties/hiringDataSourceID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs19 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.hiringRaceColumn !== undefined) {
                                                        let data10 = data.hiringRaceColumn;
                                                        const _errs21 = errors;
                                                        if (errors === _errs21) {
                                                            if (typeof data10 === 'string') {
                                                                if (func2(data10) < 1) {
                                                                    validate31.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hiringRaceColumn',
                                                                            schemaPath: '#/properties/hiringRaceColumn/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hiringRaceColumn',
                                                                        schemaPath: '#/properties/hiringRaceColumn/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs21 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.hiringPositionColumn !== undefined) {
                                                            let data11 = data.hiringPositionColumn;
                                                            const _errs23 = errors;
                                                            if (errors === _errs23) {
                                                                if (typeof data11 === 'string') {
                                                                    if (func2(data11) < 1) {
                                                                        validate31.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hiringPositionColumn',
                                                                                schemaPath: '#/properties/hiringPositionColumn/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate31.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hiringPositionColumn',
                                                                            schemaPath: '#/properties/hiringPositionColumn/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs23 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.hiringDateColumn !== undefined) {
                                                                let data12 = data.hiringDateColumn;
                                                                const _errs25 = errors;
                                                                if (errors === _errs25) {
                                                                    if (typeof data12 === 'string') {
                                                                        if (func2(data12) < 1) {
                                                                            validate31.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/hiringDateColumn',
                                                                                    schemaPath: '#/properties/hiringDateColumn/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate31.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hiringDateColumn',
                                                                                schemaPath: '#/properties/hiringDateColumn/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs25 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.hiringSeniorityColumn !== undefined) {
                                                                    let data13 = data.hiringSeniorityColumn;
                                                                    const _errs27 = errors;
                                                                    if (errors === _errs27) {
                                                                        if (typeof data13 === 'string') {
                                                                            if (func2(data13) < 1) {
                                                                                validate31.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/hiringSeniorityColumn',
                                                                                        schemaPath: '#/properties/hiringSeniorityColumn/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate31.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/hiringSeniorityColumn',
                                                                                    schemaPath: '#/properties/hiringSeniorityColumn/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid0 = _errs27 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.hiringExecutiveValue !== undefined) {
                                                                        let data14 = data.hiringExecutiveValue;
                                                                        const _errs29 = errors;
                                                                        if (errors === _errs29) {
                                                                            if (typeof data14 === 'string') {
                                                                                if (func2(data14) < 1) {
                                                                                    validate31.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/hiringExecutiveValue',
                                                                                            schemaPath: '#/properties/hiringExecutiveValue/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate31.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/hiringExecutiveValue',
                                                                                        schemaPath: '#/properties/hiringExecutiveValue/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid0 = _errs29 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.hiringHiredColumn !== undefined) {
                                                                            let data15 = data.hiringHiredColumn;
                                                                            const _errs31 = errors;
                                                                            if (errors === _errs31) {
                                                                                if (typeof data15 === 'string') {
                                                                                    if (func2(data15) < 1) {
                                                                                        validate31.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/hiringHiredColumn',
                                                                                                schemaPath: '#/properties/hiringHiredColumn/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate31.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/hiringHiredColumn',
                                                                                            schemaPath: '#/properties/hiringHiredColumn/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid0 = _errs31 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.hiredValue !== undefined) {
                                                                                let data16 = data.hiredValue;
                                                                                const _errs33 = errors;
                                                                                if (errors === _errs33) {
                                                                                    if (typeof data16 === 'string') {
                                                                                        if (func2(data16) < 1) {
                                                                                            validate31.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/hiredValue',
                                                                                                    schemaPath: '#/properties/hiredValue/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate31.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/hiredValue',
                                                                                                schemaPath: '#/properties/hiredValue/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid0 = _errs33 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate31.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate31.errors = vErrors;
    return errors === 0;
}
export const forecastParamsSchemaValidation = validate32;
const schema54 = { $id: 'urn:wisepipe-solution-domain:ForecastParams', type: 'object', properties: {}, required: [] };
function validate32(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:ForecastParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate32.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const forecastParamsV1SchemaValidation = validate33;
const schema55 = {
    $id: 'urn:wisepipe-solution-domain:ForecastParamsV1',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        valueColumn: { type: 'string', minLength: 1 },
        frequency: { type: 'string', enum: ['yearly', 'quarterly', 'monthly', 'weekly', 'daily'] },
        periods: { type: 'integer', minimum: 1 }
    },
    required: []
};
function validate33(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:ForecastParamsV1" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.dateColumn !== undefined) {
                let data0 = data.dateColumn;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate33.errors = [
                            {
                                instancePath: instancePath + '/dateColumn',
                                schemaPath: '#/properties/dateColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.valueColumn !== undefined) {
                    let data1 = data.valueColumn;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/valueColumn',
                                    schemaPath: '#/properties/valueColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.frequency !== undefined) {
                        let data2 = data.frequency;
                        const _errs5 = errors;
                        if (typeof data2 !== 'string') {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/frequency',
                                    schemaPath: '#/properties/frequency/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'yearly' ||
                            data2 === 'quarterly' ||
                            data2 === 'monthly' ||
                            data2 === 'weekly' ||
                            data2 === 'daily')) {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/frequency',
                                    schemaPath: '#/properties/frequency/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema55.properties.frequency.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.periods !== undefined) {
                            let data3 = data.periods;
                            const _errs7 = errors;
                            if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/periods',
                                        schemaPath: '#/properties/periods/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer'
                                    }
                                ];
                                return false;
                            }
                            if (errors === _errs7) {
                                if (typeof data3 == 'number') {
                                    if (data3 < 1 || isNaN(data3)) {
                                        validate33.errors = [
                                            {
                                                instancePath: instancePath + '/periods',
                                                schemaPath: '#/properties/periods/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 1 },
                                                message: 'must be >= 1'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate33.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate33.errors = vErrors;
    return errors === 0;
}
export const genderPayGapParamsSchemaValidation = validate34;
const schema56 = {
    $id: 'urn:wisepipe-solution-domain:GenderPayGapParams',
    type: 'object',
    properties: {
        genderColumn: { type: 'string', minLength: 1 },
        maleValue: { type: 'string', minLength: 1 },
        femaleValue: { type: 'string', minLength: 1 },
        payRateColumn: { type: 'string', minLength: 1 },
        payRateFrequency: { type: 'string', minLength: 1 },
        bonusColumn: { type: 'string', minLength: 1 },
        bonusFrequency: { type: 'string', minLength: 1 },
        positionColumn: { type: 'string', minLength: 1 }
    },
    required: []
};
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:GenderPayGapParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.genderColumn !== undefined) {
                let data0 = data.genderColumn;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/genderColumn',
                                    schemaPath: '#/properties/genderColumn/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate34.errors = [
                            {
                                instancePath: instancePath + '/genderColumn',
                                schemaPath: '#/properties/genderColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.maleValue !== undefined) {
                    let data1 = data.maleValue;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/maleValue',
                                        schemaPath: '#/properties/maleValue/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/maleValue',
                                    schemaPath: '#/properties/maleValue/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.femaleValue !== undefined) {
                        let data2 = data.femaleValue;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/femaleValue',
                                            schemaPath: '#/properties/femaleValue/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/femaleValue',
                                        schemaPath: '#/properties/femaleValue/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.payRateColumn !== undefined) {
                            let data3 = data.payRateColumn;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate34.errors = [
                                            {
                                                instancePath: instancePath + '/payRateColumn',
                                                schemaPath: '#/properties/payRateColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/payRateColumn',
                                            schemaPath: '#/properties/payRateColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.payRateFrequency !== undefined) {
                                let data4 = data.payRateFrequency;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate34.errors = [
                                                {
                                                    instancePath: instancePath + '/payRateFrequency',
                                                    schemaPath: '#/properties/payRateFrequency/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate34.errors = [
                                            {
                                                instancePath: instancePath + '/payRateFrequency',
                                                schemaPath: '#/properties/payRateFrequency/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.bonusColumn !== undefined) {
                                    let data5 = data.bonusColumn;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate34.errors = [
                                                    {
                                                        instancePath: instancePath + '/bonusColumn',
                                                        schemaPath: '#/properties/bonusColumn/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate34.errors = [
                                                {
                                                    instancePath: instancePath + '/bonusColumn',
                                                    schemaPath: '#/properties/bonusColumn/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.bonusFrequency !== undefined) {
                                        let data6 = data.bonusFrequency;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data6 === 'string') {
                                                if (func2(data6) < 1) {
                                                    validate34.errors = [
                                                        {
                                                            instancePath: instancePath + '/bonusFrequency',
                                                            schemaPath: '#/properties/bonusFrequency/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate34.errors = [
                                                    {
                                                        instancePath: instancePath + '/bonusFrequency',
                                                        schemaPath: '#/properties/bonusFrequency/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.positionColumn !== undefined) {
                                            let data7 = data.positionColumn;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data7 === 'string') {
                                                    if (func2(data7) < 1) {
                                                        validate34.errors = [
                                                            {
                                                                instancePath: instancePath + '/positionColumn',
                                                                schemaPath: '#/properties/positionColumn/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate34.errors = [
                                                        {
                                                            instancePath: instancePath + '/positionColumn',
                                                            schemaPath: '#/properties/positionColumn/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate34.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const matchColumnSchemaValidation = validate35;
const schema57 = {
    $id: 'urn:wisepipe-solution-domain:MatchColumn',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        columnType: { type: 'string', enum: ['string', 'number', 'date', 'boolean'] },
        uniqueCount: { type: 'number', minimum: 0 },
        uniquePercent: { type: 'number', minimum: 0, maximum: 1 },
        emptyCount: { type: 'number', minimum: 0 },
        emptyPercent: { type: 'number', minimum: 0, maximum: 1 },
        frequent1: { type: 'string' },
        frequent1Percent: { type: 'number', minimum: 0, maximum: 1 },
        frequent2: { type: 'string' },
        frequent2Percent: { type: 'number', minimum: 0, maximum: 1 }
    },
    required: ['name', 'columnType', 'uniqueCount', 'uniquePercent', 'emptyCount', 'emptyPercent']
};
function validate35(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:MatchColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.columnType === undefined && (missing0 = 'columnType')) ||
                (data.uniqueCount === undefined && (missing0 = 'uniqueCount')) ||
                (data.uniquePercent === undefined && (missing0 = 'uniquePercent')) ||
                (data.emptyCount === undefined && (missing0 = 'emptyCount')) ||
                (data.emptyPercent === undefined && (missing0 = 'emptyPercent'))) {
                validate35.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate35.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columnType !== undefined) {
                        let data1 = data.columnType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate35.errors = [
                                {
                                    instancePath: instancePath + '/columnType',
                                    schemaPath: '#/properties/columnType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'string' || data1 === 'number' || data1 === 'date' || data1 === 'boolean')) {
                            validate35.errors = [
                                {
                                    instancePath: instancePath + '/columnType',
                                    schemaPath: '#/properties/columnType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema57.properties.columnType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.uniqueCount !== undefined) {
                            let data2 = data.uniqueCount;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/uniqueCount',
                                                schemaPath: '#/properties/uniqueCount/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/uniqueCount',
                                            schemaPath: '#/properties/uniqueCount/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.uniquePercent !== undefined) {
                                let data3 = data.uniquePercent;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 > 1 || isNaN(data3)) {
                                            validate35.errors = [
                                                {
                                                    instancePath: instancePath + '/uniquePercent',
                                                    schemaPath: '#/properties/uniquePercent/maximum',
                                                    keyword: 'maximum',
                                                    params: { comparison: '<=', limit: 1 },
                                                    message: 'must be <= 1'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data3 < 0 || isNaN(data3)) {
                                                validate35.errors = [
                                                    {
                                                        instancePath: instancePath + '/uniquePercent',
                                                        schemaPath: '#/properties/uniquePercent/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 0 },
                                                        message: 'must be >= 0'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/uniquePercent',
                                                schemaPath: '#/properties/uniquePercent/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.emptyCount !== undefined) {
                                    let data4 = data.emptyCount;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 == 'number') {
                                            if (data4 < 0 || isNaN(data4)) {
                                                validate35.errors = [
                                                    {
                                                        instancePath: instancePath + '/emptyCount',
                                                        schemaPath: '#/properties/emptyCount/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 0 },
                                                        message: 'must be >= 0'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate35.errors = [
                                                {
                                                    instancePath: instancePath + '/emptyCount',
                                                    schemaPath: '#/properties/emptyCount/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.emptyPercent !== undefined) {
                                        let data5 = data.emptyPercent;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 == 'number') {
                                                if (data5 > 1 || isNaN(data5)) {
                                                    validate35.errors = [
                                                        {
                                                            instancePath: instancePath + '/emptyPercent',
                                                            schemaPath: '#/properties/emptyPercent/maximum',
                                                            keyword: 'maximum',
                                                            params: { comparison: '<=', limit: 1 },
                                                            message: 'must be <= 1'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5 < 0 || isNaN(data5)) {
                                                        validate35.errors = [
                                                            {
                                                                instancePath: instancePath + '/emptyPercent',
                                                                schemaPath: '#/properties/emptyPercent/minimum',
                                                                keyword: 'minimum',
                                                                params: { comparison: '>=', limit: 0 },
                                                                message: 'must be >= 0'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate35.errors = [
                                                    {
                                                        instancePath: instancePath + '/emptyPercent',
                                                        schemaPath: '#/properties/emptyPercent/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.frequent1 !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.frequent1 !== 'string') {
                                                validate35.errors = [
                                                    {
                                                        instancePath: instancePath + '/frequent1',
                                                        schemaPath: '#/properties/frequent1/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.frequent1Percent !== undefined) {
                                                let data7 = data.frequent1Percent;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (typeof data7 == 'number') {
                                                        if (data7 > 1 || isNaN(data7)) {
                                                            validate35.errors = [
                                                                {
                                                                    instancePath: instancePath + '/frequent1Percent',
                                                                    schemaPath: '#/properties/frequent1Percent/maximum',
                                                                    keyword: 'maximum',
                                                                    params: { comparison: '<=', limit: 1 },
                                                                    message: 'must be <= 1'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data7 < 0 || isNaN(data7)) {
                                                                validate35.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/frequent1Percent',
                                                                        schemaPath: '#/properties/frequent1Percent/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate35.errors = [
                                                            {
                                                                instancePath: instancePath + '/frequent1Percent',
                                                                schemaPath: '#/properties/frequent1Percent/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.frequent2 !== undefined) {
                                                    const _errs17 = errors;
                                                    if (typeof data.frequent2 !== 'string') {
                                                        validate35.errors = [
                                                            {
                                                                instancePath: instancePath + '/frequent2',
                                                                schemaPath: '#/properties/frequent2/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.frequent2Percent !== undefined) {
                                                        let data9 = data.frequent2Percent;
                                                        const _errs19 = errors;
                                                        if (errors === _errs19) {
                                                            if (typeof data9 == 'number') {
                                                                if (data9 > 1 || isNaN(data9)) {
                                                                    validate35.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/frequent2Percent',
                                                                            schemaPath: '#/properties/frequent2Percent/maximum',
                                                                            keyword: 'maximum',
                                                                            params: { comparison: '<=', limit: 1 },
                                                                            message: 'must be <= 1'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data9 < 0 || isNaN(data9)) {
                                                                        validate35.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/frequent2Percent',
                                                                                schemaPath: '#/properties/frequent2Percent/minimum',
                                                                                keyword: 'minimum',
                                                                                params: { comparison: '>=', limit: 0 },
                                                                                message: 'must be >= 0'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate35.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/frequent2Percent',
                                                                        schemaPath: '#/properties/frequent2Percent/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate35.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate35.errors = vErrors;
    return errors === 0;
}
export const matchDataSchemaValidation = validate36;
const schema58 = {
    $id: 'urn:wisepipe-solution-domain:MatchData',
    type: 'object',
    properties: {
        rows: { type: 'number', minimum: 0 },
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-solution-domain:MatchColumn' },
            uniqueItemProperties: ['name']
        }
    },
    required: ['rows', 'columns']
};
const func155 = ajvEqual;
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:MatchData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.rows === undefined && (missing0 = 'rows')) || (data.columns === undefined && (missing0 = 'columns'))) {
                validate36.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.rows !== undefined) {
                    let data0 = data.rows;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 0 || isNaN(data0)) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/rows',
                                        schemaPath: '#/properties/rows/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/rows',
                                    schemaPath: '#/properties/rows/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columns !== undefined) {
                        let data1 = data.columns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if ((data2.name === undefined && (missing1 = 'name')) ||
                                                (data2.columnType === undefined && (missing1 = 'columnType')) ||
                                                (data2.uniqueCount === undefined && (missing1 = 'uniqueCount')) ||
                                                (data2.uniquePercent === undefined && (missing1 = 'uniquePercent')) ||
                                                (data2.emptyCount === undefined && (missing1 = 'emptyCount')) ||
                                                (data2.emptyPercent === undefined && (missing1 = 'emptyPercent'))) {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.name !== undefined) {
                                                    let data3 = data2.name;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 === 'string') {
                                                            if (func2(data3) < 1) {
                                                                validate36.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columns/' + i0 + '/name',
                                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/name/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate36.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns/' + i0 + '/name',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/name/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.columnType !== undefined) {
                                                        let data4 = data2.columnType;
                                                        const _errs10 = errors;
                                                        if (typeof data4 !== 'string') {
                                                            validate36.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns/' + i0 + '/columnType',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/columnType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data4 === 'string' || data4 === 'number' || data4 === 'date' || data4 === 'boolean')) {
                                                            validate36.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns/' + i0 + '/columnType',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/columnType/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema57.properties.columnType.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data2.uniqueCount !== undefined) {
                                                            let data5 = data2.uniqueCount;
                                                            const _errs12 = errors;
                                                            if (errors === _errs12) {
                                                                if (typeof data5 == 'number') {
                                                                    if (data5 < 0 || isNaN(data5)) {
                                                                        validate36.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/uniqueCount',
                                                                                schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/uniqueCount/minimum',
                                                                                keyword: 'minimum',
                                                                                params: { comparison: '>=', limit: 0 },
                                                                                message: 'must be >= 0'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate36.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/uniqueCount',
                                                                            schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/uniqueCount/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'number' },
                                                                            message: 'must be number'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data2.uniquePercent !== undefined) {
                                                                let data6 = data2.uniquePercent;
                                                                const _errs14 = errors;
                                                                if (errors === _errs14) {
                                                                    if (typeof data6 == 'number') {
                                                                        if (data6 > 1 || isNaN(data6)) {
                                                                            validate36.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/uniquePercent',
                                                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/uniquePercent/maximum',
                                                                                    keyword: 'maximum',
                                                                                    params: { comparison: '<=', limit: 1 },
                                                                                    message: 'must be <= 1'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (data6 < 0 || isNaN(data6)) {
                                                                                validate36.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/columns/' + i0 + '/uniquePercent',
                                                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/uniquePercent/minimum',
                                                                                        keyword: 'minimum',
                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                        message: 'must be >= 0'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate36.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/uniquePercent',
                                                                                schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/uniquePercent/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid3 = _errs14 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                            if (valid3) {
                                                                if (data2.emptyCount !== undefined) {
                                                                    let data7 = data2.emptyCount;
                                                                    const _errs16 = errors;
                                                                    if (errors === _errs16) {
                                                                        if (typeof data7 == 'number') {
                                                                            if (data7 < 0 || isNaN(data7)) {
                                                                                validate36.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/columns/' + i0 + '/emptyCount',
                                                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/emptyCount/minimum',
                                                                                        keyword: 'minimum',
                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                        message: 'must be >= 0'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate36.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/emptyCount',
                                                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/emptyCount/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'number' },
                                                                                    message: 'must be number'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid3 = _errs16 === errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                                if (valid3) {
                                                                    if (data2.emptyPercent !== undefined) {
                                                                        let data8 = data2.emptyPercent;
                                                                        const _errs18 = errors;
                                                                        if (errors === _errs18) {
                                                                            if (typeof data8 == 'number') {
                                                                                if (data8 > 1 || isNaN(data8)) {
                                                                                    validate36.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/columns/' + i0 + '/emptyPercent',
                                                                                            schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/emptyPercent/maximum',
                                                                                            keyword: 'maximum',
                                                                                            params: { comparison: '<=', limit: 1 },
                                                                                            message: 'must be <= 1'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    if (data8 < 0 || isNaN(data8)) {
                                                                                        validate36.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/emptyPercent',
                                                                                                schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/emptyPercent/minimum',
                                                                                                keyword: 'minimum',
                                                                                                params: { comparison: '>=', limit: 0 },
                                                                                                message: 'must be >= 0'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate36.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/columns/' + i0 + '/emptyPercent',
                                                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/emptyPercent/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'number' },
                                                                                        message: 'must be number'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid3 = _errs18 === errors;
                                                                    }
                                                                    else {
                                                                        var valid3 = true;
                                                                    }
                                                                    if (valid3) {
                                                                        if (data2.frequent1 !== undefined) {
                                                                            const _errs20 = errors;
                                                                            if (typeof data2.frequent1 !== 'string') {
                                                                                validate36.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/columns/' + i0 + '/frequent1',
                                                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/frequent1/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid3 = _errs20 === errors;
                                                                        }
                                                                        else {
                                                                            var valid3 = true;
                                                                        }
                                                                        if (valid3) {
                                                                            if (data2.frequent1Percent !== undefined) {
                                                                                let data10 = data2.frequent1Percent;
                                                                                const _errs22 = errors;
                                                                                if (errors === _errs22) {
                                                                                    if (typeof data10 == 'number') {
                                                                                        if (data10 > 1 || isNaN(data10)) {
                                                                                            validate36.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/columns/' + i0 + '/frequent1Percent',
                                                                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/frequent1Percent/maximum',
                                                                                                    keyword: 'maximum',
                                                                                                    params: { comparison: '<=', limit: 1 },
                                                                                                    message: 'must be <= 1'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            if (data10 < 0 || isNaN(data10)) {
                                                                                                validate36.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/columns/' + i0 + '/frequent1Percent',
                                                                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/frequent1Percent/minimum',
                                                                                                        keyword: 'minimum',
                                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                                        message: 'must be >= 0'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate36.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/frequent1Percent',
                                                                                                schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/frequent1Percent/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'number' },
                                                                                                message: 'must be number'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid3 = _errs22 === errors;
                                                                            }
                                                                            else {
                                                                                var valid3 = true;
                                                                            }
                                                                            if (valid3) {
                                                                                if (data2.frequent2 !== undefined) {
                                                                                    const _errs24 = errors;
                                                                                    if (typeof data2.frequent2 !== 'string') {
                                                                                        validate36.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/columns/' + i0 + '/frequent2',
                                                                                                schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/frequent2/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid3 = _errs24 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid3 = true;
                                                                                }
                                                                                if (valid3) {
                                                                                    if (data2.frequent2Percent !== undefined) {
                                                                                        let data12 = data2.frequent2Percent;
                                                                                        const _errs26 = errors;
                                                                                        if (errors === _errs26) {
                                                                                            if (typeof data12 == 'number') {
                                                                                                if (data12 > 1 || isNaN(data12)) {
                                                                                                    validate36.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/columns/' + i0 + '/frequent2Percent',
                                                                                                            schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/frequent2Percent/maximum',
                                                                                                            keyword: 'maximum',
                                                                                                            params: { comparison: '<=', limit: 1 },
                                                                                                            message: 'must be <= 1'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    if (data12 < 0 || isNaN(data12)) {
                                                                                                        validate36.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/columns/' + i0 + '/frequent2Percent',
                                                                                                                schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/frequent2Percent/minimum',
                                                                                                                keyword: 'minimum',
                                                                                                                params: { comparison: '>=', limit: 0 },
                                                                                                                message: 'must be >= 0'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate36.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/columns/' + i0 + '/frequent2Percent',
                                                                                                        schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/properties/frequent2Percent/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'number' },
                                                                                                        message: 'must be number'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid3 = _errs26 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid3 = true;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate36.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: 'urn:wisepipe-solution-domain:MatchColumn/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema58.properties.columns.uniqueItemProperties;
                                    let k0;
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i1 = data1.length; i1--;) {
                                                let x0 = data1[i1];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i1; j0--;) {
                                                    let y0 = data1[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func155(x0[key0], y0[key0])) {
                                                        validate36.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns',
                                                                schemaPath: '#/properties/columns/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate36.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
export const matchDataTasksSchemaValidation = validate37;
const schema60 = {
    $id: 'urn:wisepipe-solution-domain:MatchDataTasks',
    type: 'object',
    properties: {
        sample: { $ref: 'urn:wisepipe-compute-activity-domain:TaskInput' },
        metadata: { $ref: 'urn:wisepipe-compute-activity-domain:PythonTaskInput' }
    },
    required: ['sample', 'metadata']
};
const schema61 = {
    $id: 'urn:wisepipe-compute-activity-domain:TaskInput',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['spark', 'spark-v2', 'python', 'python-eks', 'stepFunction'] },
        id: { type: 'string', minLength: 1, maxLength: 200 },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        highMemory: { type: 'boolean' },
        enableUsagesStream: { type: 'boolean' },
        logGroup: { type: 'string' },
        logStreamPrefix: { type: 'string' }
    },
    required: ['type', 'id', 'orgID']
};
const schema62 = {
    $id: 'urn:wisepipe-compute-activity-domain:PythonTaskInput',
    type: 'object',
    properties: {
        stage: { type: 'string', minLength: 1 },
        objectType: {
            type: 'string',
            enum: [
                'unknown',
                'pipe',
                'calculation',
                'import',
                'import_rowcount',
                'unit_test_data_import',
                'unit_test_data_rowcount',
                'unit_test_snapshot_import',
                'run',
                'download',
                'match',
                'export',
                'lock',
                'unit_test',
                'restore',
                'incentives_data_processing'
            ]
        },
        requester: { type: 'string', minLength: 1 },
        route: { type: 'string', minLength: 1, maxLength: 200 },
        code: { $ref: 'urn:wisepipe-common:S3File' },
        call: { type: 'string', minLength: 1 },
        timeoutMs: { type: 'number', minimum: -1 },
        usage: { $ref: 'urn:wisepipe-usages-domain:UsageInput' },
        pythonEngineVersion: { type: 'string', enum: ['1', '2', '3'] },
        pyJobRequestType: {
            type: 'string',
            enum: [
                'unknown',
                'calculation',
                'calculation_ml',
                'sample',
                'import',
                'run',
                'run_ml',
                'download',
                'export',
                'match',
                'data_profile',
                'inference',
                'monitoring',
                'lock',
                'unit_test',
                'restore',
                'incentives_data_processing'
            ]
        },
        extras: { type: 'object' },
        highMemory: { type: 'boolean' }
    },
    required: ['route', 'code', 'call', 'timeoutMs']
};
const schema63 = {
    $id: 'urn:wisepipe-common:S3File',
    type: 'object',
    properties: {
        bucket: { type: 'string', minLength: 1 },
        key: { type: 'string', minLength: 1 },
        uploadID: { type: 'string', uid: 9 }
    },
    required: ['bucket', 'key']
};
const schema64 = {
    $id: 'urn:wisepipe-usages-domain:UsageInput',
    type: 'object',
    properties: {
        stream: { type: 'string' },
        userID: { type: 'string', format: 'uuid' },
        orgID: { type: 'string', format: 'uuid' },
        details: { type: 'array', items: { type: 'string', minLength: 1 } },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] }
    },
    required: ['stream', 'userID', 'orgID', 'details']
};
const func164 = ucs2length;
const func165 = base64urlToBuffer;
const func166 = base64urlEncode;
const func167 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate38(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-compute-activity-domain:PythonTaskInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.route === undefined && (missing0 = 'route')) ||
                (data.code === undefined && (missing0 = 'code')) ||
                (data.call === undefined && (missing0 = 'call')) ||
                (data.timeoutMs === undefined && (missing0 = 'timeoutMs'))) {
                validate38.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.stage !== undefined) {
                    let data0 = data.stage;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/stage',
                                        schemaPath: '#/properties/stage/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate38.errors = [
                                {
                                    instancePath: instancePath + '/stage',
                                    schemaPath: '#/properties/stage/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.objectType !== undefined) {
                        let data1 = data.objectType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate38.errors = [
                                {
                                    instancePath: instancePath + '/objectType',
                                    schemaPath: '#/properties/objectType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'unknown' ||
                            data1 === 'pipe' ||
                            data1 === 'calculation' ||
                            data1 === 'import' ||
                            data1 === 'import_rowcount' ||
                            data1 === 'unit_test_data_import' ||
                            data1 === 'unit_test_data_rowcount' ||
                            data1 === 'unit_test_snapshot_import' ||
                            data1 === 'run' ||
                            data1 === 'download' ||
                            data1 === 'match' ||
                            data1 === 'export' ||
                            data1 === 'lock' ||
                            data1 === 'unit_test' ||
                            data1 === 'restore' ||
                            data1 === 'incentives_data_processing')) {
                            validate38.errors = [
                                {
                                    instancePath: instancePath + '/objectType',
                                    schemaPath: '#/properties/objectType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema62.properties.objectType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.requester !== undefined) {
                            let data2 = data.requester;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate38.errors = [
                                            {
                                                instancePath: instancePath + '/requester',
                                                schemaPath: '#/properties/requester/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/requester',
                                            schemaPath: '#/properties/requester/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.route !== undefined) {
                                let data3 = data.route;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) > 200) {
                                            validate38.errors = [
                                                {
                                                    instancePath: instancePath + '/route',
                                                    schemaPath: '#/properties/route/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 200 },
                                                    message: 'must NOT have more than 200 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (func2(data3) < 1) {
                                                validate38.errors = [
                                                    {
                                                        instancePath: instancePath + '/route',
                                                        schemaPath: '#/properties/route/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate38.errors = [
                                            {
                                                instancePath: instancePath + '/route',
                                                schemaPath: '#/properties/route/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.code !== undefined) {
                                    let data4 = data.code;
                                    const _errs9 = errors;
                                    const _errs10 = errors;
                                    if (errors === _errs10) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            let missing1;
                                            if ((data4.bucket === undefined && (missing1 = 'bucket')) ||
                                                (data4.key === undefined && (missing1 = 'key'))) {
                                                validate38.errors = [
                                                    {
                                                        instancePath: instancePath + '/code',
                                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data4.bucket !== undefined) {
                                                    let data5 = data4.bucket;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            if (func2(data5) < 1) {
                                                                validate38.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/code/bucket',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate38.errors = [
                                                                {
                                                                    instancePath: instancePath + '/code/bucket',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data4.key !== undefined) {
                                                        let data6 = data4.key;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data6 === 'string') {
                                                                if (func2(data6) < 1) {
                                                                    validate38.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/code/key',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate38.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/code/key',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data4.uploadID !== undefined) {
                                                            let data7 = data4.uploadID;
                                                            const _errs16 = errors;
                                                            if (errors === _errs16) {
                                                                if (typeof data7 === 'string') {
                                                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                                    if (func164(data7) < b64min0 || func164(data7) > b64max0) {
                                                                        validate38.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/code/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                keyword: 'uid',
                                                                                params: {
                                                                                    error: 'encoded',
                                                                                    b64min: b64min0,
                                                                                    b64max: b64max0,
                                                                                    length: func164(data7)
                                                                                },
                                                                                message: 'length must be between ' +
                                                                                    b64min0 +
                                                                                    ' and ' +
                                                                                    b64max0 +
                                                                                    ', but is ' +
                                                                                    func164(data7)
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const decoded0 = func165(data7);
                                                                        if (decoded0.length !== 9) {
                                                                            validate38.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/code/uploadID',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'decoded' },
                                                                                    message: 'must decode to 9 bytes'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const encoded0 = func166(decoded0);
                                                                            if (func167(encoded0) !== func167(data7)) {
                                                                                validate38.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/code/uploadID',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'ambiguous' },
                                                                                        message: 'encoding is ambiguous'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate38.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/code/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid2 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate38.errors = [
                                                {
                                                    instancePath: instancePath + '/code',
                                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.call !== undefined) {
                                        let data8 = data.call;
                                        const _errs18 = errors;
                                        if (errors === _errs18) {
                                            if (typeof data8 === 'string') {
                                                if (func2(data8) < 1) {
                                                    validate38.errors = [
                                                        {
                                                            instancePath: instancePath + '/call',
                                                            schemaPath: '#/properties/call/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate38.errors = [
                                                    {
                                                        instancePath: instancePath + '/call',
                                                        schemaPath: '#/properties/call/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs18 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.timeoutMs !== undefined) {
                                            let data9 = data.timeoutMs;
                                            const _errs20 = errors;
                                            if (errors === _errs20) {
                                                if (typeof data9 == 'number') {
                                                    if (data9 < -1 || isNaN(data9)) {
                                                        validate38.errors = [
                                                            {
                                                                instancePath: instancePath + '/timeoutMs',
                                                                schemaPath: '#/properties/timeoutMs/minimum',
                                                                keyword: 'minimum',
                                                                params: { comparison: '>=', limit: -1 },
                                                                message: 'must be >= -1'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate38.errors = [
                                                        {
                                                            instancePath: instancePath + '/timeoutMs',
                                                            schemaPath: '#/properties/timeoutMs/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs20 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.usage !== undefined) {
                                                let data10 = data.usage;
                                                const _errs22 = errors;
                                                const _errs23 = errors;
                                                if (errors === _errs23) {
                                                    if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                                                        let missing2;
                                                        if ((data10.stream === undefined && (missing2 = 'stream')) ||
                                                            (data10.userID === undefined && (missing2 = 'userID')) ||
                                                            (data10.orgID === undefined && (missing2 = 'orgID')) ||
                                                            (data10.details === undefined && (missing2 = 'details'))) {
                                                            validate38.errors = [
                                                                {
                                                                    instancePath: instancePath + '/usage',
                                                                    schemaPath: 'urn:wisepipe-usages-domain:UsageInput/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing2 },
                                                                    message: "must have required property '" + missing2 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data10.stream !== undefined) {
                                                                const _errs25 = errors;
                                                                if (typeof data10.stream !== 'string') {
                                                                    validate38.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/usage/stream',
                                                                            schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/stream/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid5 = _errs25 === errors;
                                                            }
                                                            else {
                                                                var valid5 = true;
                                                            }
                                                            if (valid5) {
                                                                if (data10.userID !== undefined) {
                                                                    let data12 = data10.userID;
                                                                    const _errs27 = errors;
                                                                    if (errors === _errs27) {
                                                                        if (errors === _errs27) {
                                                                            if (typeof data12 === 'string') {
                                                                                if (!formats16.test(data12)) {
                                                                                    validate38.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/usage/userID',
                                                                                            schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/userID/format',
                                                                                            keyword: 'format',
                                                                                            params: { format: 'uuid' },
                                                                                            message: 'must match format "' + 'uuid' + '"'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate38.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/usage/userID',
                                                                                        schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/userID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    var valid5 = _errs27 === errors;
                                                                }
                                                                else {
                                                                    var valid5 = true;
                                                                }
                                                                if (valid5) {
                                                                    if (data10.orgID !== undefined) {
                                                                        let data13 = data10.orgID;
                                                                        const _errs29 = errors;
                                                                        if (errors === _errs29) {
                                                                            if (errors === _errs29) {
                                                                                if (typeof data13 === 'string') {
                                                                                    if (!formats16.test(data13)) {
                                                                                        validate38.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/usage/orgID',
                                                                                                schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/orgID/format',
                                                                                                keyword: 'format',
                                                                                                params: { format: 'uuid' },
                                                                                                message: 'must match format "' + 'uuid' + '"'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate38.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/usage/orgID',
                                                                                            schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/orgID/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        var valid5 = _errs29 === errors;
                                                                    }
                                                                    else {
                                                                        var valid5 = true;
                                                                    }
                                                                    if (valid5) {
                                                                        if (data10.details !== undefined) {
                                                                            let data14 = data10.details;
                                                                            const _errs31 = errors;
                                                                            if (errors === _errs31) {
                                                                                if (Array.isArray(data14)) {
                                                                                    var valid6 = true;
                                                                                    const len0 = data14.length;
                                                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                                                        let data15 = data14[i0];
                                                                                        const _errs33 = errors;
                                                                                        if (errors === _errs33) {
                                                                                            if (typeof data15 === 'string') {
                                                                                                if (func2(data15) < 1) {
                                                                                                    validate38.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/usage/details/' + i0,
                                                                                                            schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/details/items/minLength',
                                                                                                            keyword: 'minLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate38.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/usage/details/' + i0,
                                                                                                        schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/details/items/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid6 = _errs33 === errors;
                                                                                        if (!valid6) {
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate38.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/usage/details',
                                                                                            schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/details/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'array' },
                                                                                            message: 'must be array'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid5 = _errs31 === errors;
                                                                        }
                                                                        else {
                                                                            var valid5 = true;
                                                                        }
                                                                        if (valid5) {
                                                                            if (data10.orgPlan !== undefined) {
                                                                                let data16 = data10.orgPlan;
                                                                                const _errs35 = errors;
                                                                                if (typeof data16 !== 'string') {
                                                                                    validate38.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/usage/orgPlan',
                                                                                            schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/orgPlan/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                if (!(data16 === 'Social' ||
                                                                                    data16 === 'Enterprise' ||
                                                                                    data16 === 'Integration' ||
                                                                                    data16 === 'Temp' ||
                                                                                    data16 === 'Starter' ||
                                                                                    data16 === 'Professional')) {
                                                                                    validate38.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/usage/orgPlan',
                                                                                            schemaPath: 'urn:wisepipe-usages-domain:UsageInput/properties/orgPlan/enum',
                                                                                            keyword: 'enum',
                                                                                            params: { allowedValues: schema64.properties.orgPlan.enum },
                                                                                            message: 'must be equal to one of the allowed values'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid5 = _errs35 === errors;
                                                                            }
                                                                            else {
                                                                                var valid5 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate38.errors = [
                                                            {
                                                                instancePath: instancePath + '/usage',
                                                                schemaPath: 'urn:wisepipe-usages-domain:UsageInput/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs22 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.pythonEngineVersion !== undefined) {
                                                    let data17 = data.pythonEngineVersion;
                                                    const _errs37 = errors;
                                                    if (typeof data17 !== 'string') {
                                                        validate38.errors = [
                                                            {
                                                                instancePath: instancePath + '/pythonEngineVersion',
                                                                schemaPath: '#/properties/pythonEngineVersion/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data17 === '1' || data17 === '2' || data17 === '3')) {
                                                        validate38.errors = [
                                                            {
                                                                instancePath: instancePath + '/pythonEngineVersion',
                                                                schemaPath: '#/properties/pythonEngineVersion/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema62.properties.pythonEngineVersion.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs37 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.pyJobRequestType !== undefined) {
                                                        let data18 = data.pyJobRequestType;
                                                        const _errs39 = errors;
                                                        if (typeof data18 !== 'string') {
                                                            validate38.errors = [
                                                                {
                                                                    instancePath: instancePath + '/pyJobRequestType',
                                                                    schemaPath: '#/properties/pyJobRequestType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data18 === 'unknown' ||
                                                            data18 === 'calculation' ||
                                                            data18 === 'calculation_ml' ||
                                                            data18 === 'sample' ||
                                                            data18 === 'import' ||
                                                            data18 === 'run' ||
                                                            data18 === 'run_ml' ||
                                                            data18 === 'download' ||
                                                            data18 === 'export' ||
                                                            data18 === 'match' ||
                                                            data18 === 'data_profile' ||
                                                            data18 === 'inference' ||
                                                            data18 === 'monitoring' ||
                                                            data18 === 'lock' ||
                                                            data18 === 'unit_test' ||
                                                            data18 === 'restore' ||
                                                            data18 === 'incentives_data_processing')) {
                                                            validate38.errors = [
                                                                {
                                                                    instancePath: instancePath + '/pyJobRequestType',
                                                                    schemaPath: '#/properties/pyJobRequestType/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema62.properties.pyJobRequestType.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs39 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.extras !== undefined) {
                                                            let data19 = data.extras;
                                                            const _errs41 = errors;
                                                            if (!(data19 && typeof data19 == 'object' && !Array.isArray(data19))) {
                                                                validate38.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/extras',
                                                                        schemaPath: '#/properties/extras/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs41 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.highMemory !== undefined) {
                                                                const _errs43 = errors;
                                                                if (typeof data.highMemory !== 'boolean') {
                                                                    validate38.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/highMemory',
                                                                            schemaPath: '#/properties/highMemory/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'boolean' },
                                                                            message: 'must be boolean'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs43 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate38.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate38.errors = vErrors;
    return errors === 0;
}
function validate37(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:MatchDataTasks" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.sample === undefined && (missing0 = 'sample')) ||
                (data.metadata === undefined && (missing0 = 'metadata'))) {
                validate37.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.sample !== undefined) {
                    let data0 = data.sample;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.type === undefined && (missing1 = 'type')) ||
                                (data0.id === undefined && (missing1 = 'id')) ||
                                (data0.orgID === undefined && (missing1 = 'orgID'))) {
                                validate37.errors = [
                                    {
                                        instancePath: instancePath + '/sample',
                                        schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.type !== undefined) {
                                    let data1 = data0.type;
                                    const _errs4 = errors;
                                    if (typeof data1 !== 'string') {
                                        validate37.errors = [
                                            {
                                                instancePath: instancePath + '/sample/type',
                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/type/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data1 === 'spark' ||
                                        data1 === 'spark-v2' ||
                                        data1 === 'python' ||
                                        data1 === 'python-eks' ||
                                        data1 === 'stepFunction')) {
                                        validate37.errors = [
                                            {
                                                instancePath: instancePath + '/sample/type',
                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/type/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema61.properties.type.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.id !== undefined) {
                                        let data2 = data0.id;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) > 200) {
                                                    validate37.errors = [
                                                        {
                                                            instancePath: instancePath + '/sample/id',
                                                            schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/id/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 200 },
                                                            message: 'must NOT have more than 200 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data2) < 1) {
                                                        validate37.errors = [
                                                            {
                                                                instancePath: instancePath + '/sample/id',
                                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/id/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate37.errors = [
                                                    {
                                                        instancePath: instancePath + '/sample/id',
                                                        schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/id/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.orgID !== undefined) {
                                            let data3 = data0.orgID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (errors === _errs8) {
                                                    if (typeof data3 === 'string') {
                                                        if (!formats16.test(data3)) {
                                                            validate37.errors = [
                                                                {
                                                                    instancePath: instancePath + '/sample/orgID',
                                                                    schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/orgID/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'uuid' },
                                                                    message: 'must match format "' + 'uuid' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate37.errors = [
                                                            {
                                                                instancePath: instancePath + '/sample/orgID',
                                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/orgID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data0.orgPlan !== undefined) {
                                                let data4 = data0.orgPlan;
                                                const _errs10 = errors;
                                                if (typeof data4 !== 'string') {
                                                    validate37.errors = [
                                                        {
                                                            instancePath: instancePath + '/sample/orgPlan',
                                                            schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/orgPlan/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data4 === 'Social' ||
                                                    data4 === 'Enterprise' ||
                                                    data4 === 'Integration' ||
                                                    data4 === 'Temp' ||
                                                    data4 === 'Starter' ||
                                                    data4 === 'Professional')) {
                                                    validate37.errors = [
                                                        {
                                                            instancePath: instancePath + '/sample/orgPlan',
                                                            schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/orgPlan/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema61.properties.orgPlan.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data0.highMemory !== undefined) {
                                                    const _errs12 = errors;
                                                    if (typeof data0.highMemory !== 'boolean') {
                                                        validate37.errors = [
                                                            {
                                                                instancePath: instancePath + '/sample/highMemory',
                                                                schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/highMemory/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data0.enableUsagesStream !== undefined) {
                                                        const _errs14 = errors;
                                                        if (typeof data0.enableUsagesStream !== 'boolean') {
                                                            validate37.errors = [
                                                                {
                                                                    instancePath: instancePath + '/sample/enableUsagesStream',
                                                                    schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/enableUsagesStream/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data0.logGroup !== undefined) {
                                                            const _errs16 = errors;
                                                            if (typeof data0.logGroup !== 'string') {
                                                                validate37.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/sample/logGroup',
                                                                        schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/logGroup/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid2 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (data0.logStreamPrefix !== undefined) {
                                                                const _errs18 = errors;
                                                                if (typeof data0.logStreamPrefix !== 'string') {
                                                                    validate37.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/sample/logStreamPrefix',
                                                                            schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/properties/logStreamPrefix/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid2 = _errs18 === errors;
                                                            }
                                                            else {
                                                                var valid2 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate37.errors = [
                                {
                                    instancePath: instancePath + '/sample',
                                    schemaPath: 'urn:wisepipe-compute-activity-domain:TaskInput/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.metadata !== undefined) {
                        const _errs20 = errors;
                        if (!validate38(data.metadata, {
                            instancePath: instancePath + '/metadata',
                            parentData: data,
                            parentDataProperty: 'metadata',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs20 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate37.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate37.errors = vErrors;
    return errors === 0;
}
export const matchTaskSchemaValidation = validate40;
const func171 = ucs2length;
const func172 = base64urlToBuffer;
const func173 = base64urlEncode;
const func174 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate40(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:MatchTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.dataSourceID === undefined && (missing0 = 'dataSourceID'))) {
                validate40.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.taskID !== undefined) {
                    let data0 = data.taskID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate40.errors = [
                                {
                                    instancePath: instancePath + '/taskID',
                                    schemaPath: '#/properties/taskID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgID !== undefined) {
                        let data1 = data.orgID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats16.test(data1)) {
                                        validate40.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate40.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgPlan !== undefined) {
                            let data2 = data.orgPlan;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/orgPlan',
                                        schemaPath: '#/properties/orgPlan/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'Social' ||
                                data2 === 'Enterprise' ||
                                data2 === 'Integration' ||
                                data2 === 'Temp' ||
                                data2 === 'Starter' ||
                                data2 === 'Professional')) {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/orgPlan',
                                        schemaPath: '#/properties/orgPlan/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema51.properties.orgPlan.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.dataSourceID !== undefined) {
                                let data3 = data.dataSourceID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min0 = Math.ceil((4 * 9) / 3);
                                        const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func171(data3) < b64min0 || func171(data3) > b64max0) {
                                            validate40.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func171(data3) },
                                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func171(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded0 = func172(data3);
                                            if (decoded0.length !== 9) {
                                                validate40.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded0 = func173(decoded0);
                                                if (func174(encoded0) !== func174(data3)) {
                                                    validate40.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataSourceID',
                                                            schemaPath: '#/properties/dataSourceID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate40.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate40.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate40.errors = vErrors;
    return errors === 0;
}
export const newSolutionTaskSchemaValidation = validate41;
const schema66 = {
    $id: 'urn:wisepipe-solution-domain:NewSolutionTask',
    type: 'object',
    properties: {
        taskID: { type: 'string', minLength: 1 },
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        request: { $ref: 'urn:wisepipe-solution-domain:SolutionRequest' },
        pipe: { $ref: 'urn:wisepipe-base-pipe:Pipe' }
    },
    required: ['taskID', 'userID', 'orgID', 'request', 'pipe']
};
const schema67 = {
    $id: 'urn:wisepipe-solution-domain:SolutionRequest',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 100 },
        type: { type: 'number', minimum: 0 },
        dataSourceID: { type: 'string', uid: 9 },
        engineMode: { type: 'string', enum: ['standard', 'big'] },
        params: { $ref: 'urn:wisepipe-solution-domain:SolutionParams' }
    },
    required: ['name', 'engineMode', 'type', 'params']
};
const schema68 = {
    $id: 'urn:wisepipe-solution-domain:SolutionParams',
    type: 'object',
    properties: { type: { type: 'number', minimum: 0 } },
    required: ['type']
};
const func178 = ucs2length;
const func179 = base64urlToBuffer;
const func180 = base64urlEncode;
const func181 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate42(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SolutionRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.engineMode === undefined && (missing0 = 'engineMode')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.params === undefined && (missing0 = 'params'))) {
                validate42.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 100) {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate42.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.type !== undefined) {
                        let data1 = data.type;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.dataSourceID !== undefined) {
                            let data2 = data.dataSourceID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func178(data2) < b64min0 || func178(data2) > b64max0) {
                                        validate42.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func178(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func178(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func179(data2);
                                        if (decoded0.length !== 9) {
                                            validate42.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func180(decoded0);
                                            if (func181(encoded0) !== func181(data2)) {
                                                validate42.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.engineMode !== undefined) {
                                let data3 = data.engineMode;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/engineMode',
                                            schemaPath: '#/properties/engineMode/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'standard' || data3 === 'big')) {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/engineMode',
                                            schemaPath: '#/properties/engineMode/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema67.properties.engineMode.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.params !== undefined) {
                                    let data4 = data.params;
                                    const _errs9 = errors;
                                    const _errs10 = errors;
                                    if (errors === _errs10) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            let missing1;
                                            if (data4.type === undefined && (missing1 = 'type')) {
                                                validate42.errors = [
                                                    {
                                                        instancePath: instancePath + '/params',
                                                        schemaPath: 'urn:wisepipe-solution-domain:SolutionParams/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data4.type !== undefined) {
                                                    let data5 = data4.type;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 == 'number') {
                                                            if (data5 < 0 || isNaN(data5)) {
                                                                validate42.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/params/type',
                                                                        schemaPath: 'urn:wisepipe-solution-domain:SolutionParams/properties/type/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate42.errors = [
                                                                {
                                                                    instancePath: instancePath + '/params/type',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:SolutionParams/properties/type/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate42.errors = [
                                                {
                                                    instancePath: instancePath + '/params',
                                                    schemaPath: 'urn:wisepipe-solution-domain:SolutionParams/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate42.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate42.errors = vErrors;
    return errors === 0;
}
function validate41(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:NewSolutionTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.request === undefined && (missing0 = 'request')) ||
                (data.pipe === undefined && (missing0 = 'pipe'))) {
                validate41.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.taskID !== undefined) {
                    let data0 = data.taskID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate41.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate41.errors = [
                                {
                                    instancePath: instancePath + '/taskID',
                                    schemaPath: '#/properties/taskID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgID !== undefined) {
                        let data1 = data.orgID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats16.test(data1)) {
                                        validate41.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate41.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.userID !== undefined) {
                            let data2 = data.userID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats16.test(data2)) {
                                            validate41.errors = [
                                                {
                                                    instancePath: instancePath + '/userID',
                                                    schemaPath: '#/properties/userID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate41.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.userName !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.userName !== 'string') {
                                    validate41.errors = [
                                        {
                                            instancePath: instancePath + '/userName',
                                            schemaPath: '#/properties/userName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.userEmail !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.userEmail !== 'string') {
                                        validate41.errors = [
                                            {
                                                instancePath: instancePath + '/userEmail',
                                                schemaPath: '#/properties/userEmail/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.orgPlan !== undefined) {
                                        let data5 = data.orgPlan;
                                        const _errs11 = errors;
                                        if (typeof data5 !== 'string') {
                                            validate41.errors = [
                                                {
                                                    instancePath: instancePath + '/orgPlan',
                                                    schemaPath: '#/properties/orgPlan/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data5 === 'Social' ||
                                            data5 === 'Enterprise' ||
                                            data5 === 'Integration' ||
                                            data5 === 'Temp' ||
                                            data5 === 'Starter' ||
                                            data5 === 'Professional')) {
                                            validate41.errors = [
                                                {
                                                    instancePath: instancePath + '/orgPlan',
                                                    schemaPath: '#/properties/orgPlan/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema66.properties.orgPlan.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.request !== undefined) {
                                            const _errs13 = errors;
                                            if (!validate42(data.request, {
                                                instancePath: instancePath + '/request',
                                                parentData: data,
                                                parentDataProperty: 'request',
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.pipe !== undefined) {
                                                const _errs14 = errors;
                                                if (!validate22(data.pipe, {
                                                    instancePath: instancePath + '/pipe',
                                                    parentData: data,
                                                    parentDataProperty: 'pipe',
                                                    rootData
                                                })) {
                                                    vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
                                                    errors = vErrors.length;
                                                }
                                                var valid0 = _errs14 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate41.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate41.errors = vErrors;
    return errors === 0;
}
export const periodColumnMetadataSchemaValidation = validate45;
function validate45(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PeriodColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.level === undefined && (missing0 = 'level'))) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate45.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate45.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate45.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate45.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate45.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate45.errors = vErrors;
    return errors === 0;
}
export const picklistColumnMetadataSchemaValidation = validate46;
function validate46(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PicklistColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.table === undefined && (missing0 = 'table')) || (data.column === undefined && (missing0 = 'column'))) {
                validate46.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.table !== undefined) {
                    let data0 = data.table;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate46.errors = [
                                    {
                                        instancePath: instancePath + '/table',
                                        schemaPath: '#/properties/table/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate46.errors = [
                                {
                                    instancePath: instancePath + '/table',
                                    schemaPath: '#/properties/table/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        let data1 = data.column;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate46.errors = [
                                        {
                                            instancePath: instancePath + '/column',
                                            schemaPath: '#/properties/column/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate46.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate46.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate46.errors = vErrors;
    return errors === 0;
}
export const pipeDocumentationSchemaValidation = validate47;
function validate47(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:PipeDocumentation" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.lastModified === undefined && (missing0 = 'lastModified')) ||
                (data.content === undefined && (missing0 = 'content'))) {
                validate47.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lastModified !== undefined) {
                    let data0 = data.lastModified;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate47.errors = [
                                        {
                                            instancePath: instancePath + '/lastModified',
                                            schemaPath: '#/properties/lastModified/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate47.errors = [
                                    {
                                        instancePath: instancePath + '/lastModified',
                                        schemaPath: '#/properties/lastModified/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.content !== undefined) {
                        let data1 = data.content;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 50000) {
                                    validate47.errors = [
                                        {
                                            instancePath: instancePath + '/content',
                                            schemaPath: '#/properties/content/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 50000 },
                                            message: 'must NOT have more than 50000 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate47.errors = [
                                            {
                                                instancePath: instancePath + '/content',
                                                schemaPath: '#/properties/content/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate47.errors = [
                                    {
                                        instancePath: instancePath + '/content',
                                        schemaPath: '#/properties/content/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate47.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate47.errors = vErrors;
    return errors === 0;
}
export const pipeSchemaValidation = validate22;
export const pythonTaskInputSchemaValidation = validate38;
export const s3FileSchemaValidation = validate48;
const func190 = ucs2length;
const func191 = base64urlToBuffer;
const func192 = base64urlEncode;
const func193 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate48(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:S3File" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.bucket === undefined && (missing0 = 'bucket')) || (data.key === undefined && (missing0 = 'key'))) {
                validate48.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    let data0 = data.bucket;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate48.errors = [
                                    {
                                        instancePath: instancePath + '/bucket',
                                        schemaPath: '#/properties/bucket/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate48.errors = [
                                {
                                    instancePath: instancePath + '/bucket',
                                    schemaPath: '#/properties/bucket/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.key !== undefined) {
                        let data1 = data.key;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate48.errors = [
                                        {
                                            instancePath: instancePath + '/key',
                                            schemaPath: '#/properties/key/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate48.errors = [
                                    {
                                        instancePath: instancePath + '/key',
                                        schemaPath: '#/properties/key/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.uploadID !== undefined) {
                            let data2 = data.uploadID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func190(data2) < b64min0 || func190(data2) > b64max0) {
                                        validate48.errors = [
                                            {
                                                instancePath: instancePath + '/uploadID',
                                                schemaPath: '#/properties/uploadID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func190(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func190(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func191(data2);
                                        if (decoded0.length !== 9) {
                                            validate48.errors = [
                                                {
                                                    instancePath: instancePath + '/uploadID',
                                                    schemaPath: '#/properties/uploadID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func192(decoded0);
                                            if (func193(encoded0) !== func193(data2)) {
                                                validate48.errors = [
                                                    {
                                                        instancePath: instancePath + '/uploadID',
                                                        schemaPath: '#/properties/uploadID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate48.errors = [
                                        {
                                            instancePath: instancePath + '/uploadID',
                                            schemaPath: '#/properties/uploadID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate48.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate48.errors = vErrors;
    return errors === 0;
}
export const sellerChurnParamsSchemaValidation = validate49;
const schema73 = {
    $id: 'urn:wisepipe-solution-domain:SellerChurnParams',
    type: 'object',
    properties: {
        sellerColumn: { type: 'string', minLength: 1 },
        churnColumn: { type: 'string', minLength: 1 },
        churnValue: { type: 'string', minLength: 1 },
        performanceColumn: { type: 'string', minLength: 1 }
    },
    required: []
};
function validate49(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SellerChurnParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.sellerColumn !== undefined) {
                let data0 = data.sellerColumn;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate49.errors = [
                                {
                                    instancePath: instancePath + '/sellerColumn',
                                    schemaPath: '#/properties/sellerColumn/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate49.errors = [
                            {
                                instancePath: instancePath + '/sellerColumn',
                                schemaPath: '#/properties/sellerColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.churnColumn !== undefined) {
                    let data1 = data.churnColumn;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate49.errors = [
                                    {
                                        instancePath: instancePath + '/churnColumn',
                                        schemaPath: '#/properties/churnColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate49.errors = [
                                {
                                    instancePath: instancePath + '/churnColumn',
                                    schemaPath: '#/properties/churnColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.churnValue !== undefined) {
                        let data2 = data.churnValue;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate49.errors = [
                                        {
                                            instancePath: instancePath + '/churnValue',
                                            schemaPath: '#/properties/churnValue/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate49.errors = [
                                    {
                                        instancePath: instancePath + '/churnValue',
                                        schemaPath: '#/properties/churnValue/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.performanceColumn !== undefined) {
                            let data3 = data.performanceColumn;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate49.errors = [
                                            {
                                                instancePath: instancePath + '/performanceColumn',
                                                schemaPath: '#/properties/performanceColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate49.errors = [
                                        {
                                            instancePath: instancePath + '/performanceColumn',
                                            schemaPath: '#/properties/performanceColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate49.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate49.errors = vErrors;
    return errors === 0;
}
export const sellerPerformanceParamsSchemaValidation = validate50;
const schema74 = {
    $id: 'urn:wisepipe-solution-domain:SellerPerformanceParams',
    type: 'object',
    properties: {
        sellerIdColumn: { type: 'string', minLength: 1 },
        sellerNameColumn: { type: 'string', minLength: 1 },
        attainmentColumn: { type: 'string', minLength: 1 },
        avgDealSizeColumn: { type: 'string', minLength: 1 },
        winRateColumn: { type: 'string', minLength: 1 },
        revenueColumn: { type: 'string', minLength: 1 },
        variablePayRatioColumn: { type: 'string', minLength: 1 }
    },
    required: []
};
function validate50(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SellerPerformanceParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.sellerIdColumn !== undefined) {
                let data0 = data.sellerIdColumn;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate50.errors = [
                                {
                                    instancePath: instancePath + '/sellerIdColumn',
                                    schemaPath: '#/properties/sellerIdColumn/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate50.errors = [
                            {
                                instancePath: instancePath + '/sellerIdColumn',
                                schemaPath: '#/properties/sellerIdColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.sellerNameColumn !== undefined) {
                    let data1 = data.sellerNameColumn;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 === 'string') {
                            if (func2(data1) < 1) {
                                validate50.errors = [
                                    {
                                        instancePath: instancePath + '/sellerNameColumn',
                                        schemaPath: '#/properties/sellerNameColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate50.errors = [
                                {
                                    instancePath: instancePath + '/sellerNameColumn',
                                    schemaPath: '#/properties/sellerNameColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.attainmentColumn !== undefined) {
                        let data2 = data.attainmentColumn;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate50.errors = [
                                        {
                                            instancePath: instancePath + '/attainmentColumn',
                                            schemaPath: '#/properties/attainmentColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate50.errors = [
                                    {
                                        instancePath: instancePath + '/attainmentColumn',
                                        schemaPath: '#/properties/attainmentColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.avgDealSizeColumn !== undefined) {
                            let data3 = data.avgDealSizeColumn;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate50.errors = [
                                            {
                                                instancePath: instancePath + '/avgDealSizeColumn',
                                                schemaPath: '#/properties/avgDealSizeColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate50.errors = [
                                        {
                                            instancePath: instancePath + '/avgDealSizeColumn',
                                            schemaPath: '#/properties/avgDealSizeColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.winRateColumn !== undefined) {
                                let data4 = data.winRateColumn;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate50.errors = [
                                                {
                                                    instancePath: instancePath + '/winRateColumn',
                                                    schemaPath: '#/properties/winRateColumn/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate50.errors = [
                                            {
                                                instancePath: instancePath + '/winRateColumn',
                                                schemaPath: '#/properties/winRateColumn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.revenueColumn !== undefined) {
                                    let data5 = data.revenueColumn;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                validate50.errors = [
                                                    {
                                                        instancePath: instancePath + '/revenueColumn',
                                                        schemaPath: '#/properties/revenueColumn/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate50.errors = [
                                                {
                                                    instancePath: instancePath + '/revenueColumn',
                                                    schemaPath: '#/properties/revenueColumn/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.variablePayRatioColumn !== undefined) {
                                        let data6 = data.variablePayRatioColumn;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data6 === 'string') {
                                                if (func2(data6) < 1) {
                                                    validate50.errors = [
                                                        {
                                                            instancePath: instancePath + '/variablePayRatioColumn',
                                                            schemaPath: '#/properties/variablePayRatioColumn/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate50.errors = [
                                                    {
                                                        instancePath: instancePath + '/variablePayRatioColumn',
                                                        schemaPath: '#/properties/variablePayRatioColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate50.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate50.errors = vErrors;
    return errors === 0;
}
export const solutionAndTileSchemaValidation = validate51;
const schema75 = {
    $id: 'urn:wisepipe-solution-domain:SolutionAndTile',
    type: 'object',
    properties: {
        solution: { $ref: 'urn:wisepipe-solution-domain:Solution' },
        solutionID: { type: 'string', minLength: 1, maxLength: 200 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        type: { type: 'number', minimum: 0 },
        pipeID: { type: 'string', uid: 10 },
        status: { type: 'string', enum: ['running', 'completed', 'failed'] },
        widgetData: { $ref: 'urn:wisepipe-solution-domain:SolutionResultMap' },
        cacheData: { $ref: 'urn:wisepipe-solution-domain:SolutionResultMap' },
        mapping: { $ref: 'urn:wisepipe-solution-domain:SolutionColumnNameMap' }
    },
    required: ['solution', 'type', 'name', 'pipeID', 'status']
};
const schema78 = {
    $id: 'urn:wisepipe-solution-domain:SolutionColumnNameMap',
    type: 'object',
    propertyNames: { type: 'string' },
    additionalProperties: { type: 'string' }
};
const schema76 = {
    $id: 'urn:wisepipe-solution-domain:Solution',
    type: 'object',
    properties: {
        solutionID: { type: 'string', minLength: 1, maxLength: 200 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        type: { type: 'number', minimum: 0 },
        dataSourceID: { type: 'string', uid: 9 },
        pipeID: { type: 'string', uid: 10 },
        params: { $ref: 'urn:wisepipe-solution-domain:SolutionParams' },
        createdAt: { type: 'string', format: 'date-time' },
        version: { type: 'number', minimum: 0 },
        mapping: { $ref: 'urn:wisepipe-solution-domain:SolutionColumnNameMap' }
    },
    required: ['solutionID', 'type', 'name', 'pipeID', 'dataSourceID', 'params']
};
const func209 = ucs2length;
const func210 = base64urlToBuffer;
const func211 = base64urlEncode;
const func212 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func213 = ucs2length;
const func214 = base64urlToBuffer;
const func215 = base64urlEncode;
const func216 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate52(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:Solution" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.solutionID === undefined && (missing0 = 'solutionID')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.dataSourceID === undefined && (missing0 = 'dataSourceID')) ||
                (data.params === undefined && (missing0 = 'params'))) {
                validate52.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.solutionID !== undefined) {
                    let data0 = data.solutionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 200) {
                                validate52.errors = [
                                    {
                                        instancePath: instancePath + '/solutionID',
                                        schemaPath: '#/properties/solutionID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 200 },
                                        message: 'must NOT have more than 200 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate52.errors = [
                                        {
                                            instancePath: instancePath + '/solutionID',
                                            schemaPath: '#/properties/solutionID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate52.errors = [
                                {
                                    instancePath: instancePath + '/solutionID',
                                    schemaPath: '#/properties/solutionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate52.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate52.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate52.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.type !== undefined) {
                            let data2 = data.type;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate52.errors = [
                                            {
                                                instancePath: instancePath + '/type',
                                                schemaPath: '#/properties/type/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate52.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.dataSourceID !== undefined) {
                                let data3 = data.dataSourceID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min0 = Math.ceil((4 * 9) / 3);
                                        const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func209(data3) < b64min0 || func209(data3) > b64max0) {
                                            validate52.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func209(data3) },
                                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func209(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded0 = func210(data3);
                                            if (decoded0.length !== 9) {
                                                validate52.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded0 = func211(decoded0);
                                                if (func212(encoded0) !== func212(data3)) {
                                                    validate52.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataSourceID',
                                                            schemaPath: '#/properties/dataSourceID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate52.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.pipeID !== undefined) {
                                    let data4 = data.pipeID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            const b64min1 = Math.ceil((4 * 10) / 3);
                                            const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func213(data4) < b64min1 || func213(data4) > b64max1) {
                                                validate52.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func213(data4) },
                                                        message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func213(data4)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded1 = func214(data4);
                                                if (decoded1.length !== 10) {
                                                    validate52.errors = [
                                                        {
                                                            instancePath: instancePath + '/pipeID',
                                                            schemaPath: '#/properties/pipeID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 10 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded1 = func215(decoded1);
                                                    if (func216(encoded1) !== func216(data4)) {
                                                        validate52.errors = [
                                                            {
                                                                instancePath: instancePath + '/pipeID',
                                                                schemaPath: '#/properties/pipeID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate52.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.params !== undefined) {
                                        let data5 = data.params;
                                        const _errs11 = errors;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing1;
                                                if (data5.type === undefined && (missing1 = 'type')) {
                                                    validate52.errors = [
                                                        {
                                                            instancePath: instancePath + '/params',
                                                            schemaPath: 'urn:wisepipe-solution-domain:SolutionParams/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5.type !== undefined) {
                                                        let data6 = data5.type;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data6 == 'number') {
                                                                if (data6 < 0 || isNaN(data6)) {
                                                                    validate52.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/params/type',
                                                                            schemaPath: 'urn:wisepipe-solution-domain:SolutionParams/properties/type/minimum',
                                                                            keyword: 'minimum',
                                                                            params: { comparison: '>=', limit: 0 },
                                                                            message: 'must be >= 0'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate52.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/params/type',
                                                                        schemaPath: 'urn:wisepipe-solution-domain:SolutionParams/properties/type/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate52.errors = [
                                                    {
                                                        instancePath: instancePath + '/params',
                                                        schemaPath: 'urn:wisepipe-solution-domain:SolutionParams/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.createdAt !== undefined) {
                                            let data7 = data.createdAt;
                                            const _errs16 = errors;
                                            if (errors === _errs16) {
                                                if (errors === _errs16) {
                                                    if (typeof data7 === 'string') {
                                                        if (!formats0.validate(data7)) {
                                                            validate52.errors = [
                                                                {
                                                                    instancePath: instancePath + '/createdAt',
                                                                    schemaPath: '#/properties/createdAt/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'date-time' },
                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate52.errors = [
                                                            {
                                                                instancePath: instancePath + '/createdAt',
                                                                schemaPath: '#/properties/createdAt/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid0 = _errs16 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.version !== undefined) {
                                                let data8 = data.version;
                                                const _errs18 = errors;
                                                if (errors === _errs18) {
                                                    if (typeof data8 == 'number') {
                                                        if (data8 < 0 || isNaN(data8)) {
                                                            validate52.errors = [
                                                                {
                                                                    instancePath: instancePath + '/version',
                                                                    schemaPath: '#/properties/version/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: 0 },
                                                                    message: 'must be >= 0'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate52.errors = [
                                                            {
                                                                instancePath: instancePath + '/version',
                                                                schemaPath: '#/properties/version/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs18 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.mapping !== undefined) {
                                                    let data9 = data.mapping;
                                                    const _errs20 = errors;
                                                    const _errs21 = errors;
                                                    if (errors === _errs21) {
                                                        if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                                                            for (const key0 in data9) {
                                                                const _errs23 = errors;
                                                                if (typeof key0 !== 'string') {
                                                                    const err0 = {
                                                                        instancePath: instancePath + '/mapping',
                                                                        schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/propertyNames/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string',
                                                                        propertyName: key0
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err0];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err0);
                                                                    }
                                                                    errors++;
                                                                }
                                                                var valid6 = _errs23 === errors;
                                                                if (!valid6) {
                                                                    const err1 = {
                                                                        instancePath: instancePath + '/mapping',
                                                                        schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/propertyNames',
                                                                        keyword: 'propertyNames',
                                                                        params: { propertyName: key0 },
                                                                        message: 'property name must be valid'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err1];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err1);
                                                                    }
                                                                    errors++;
                                                                    validate52.errors = vErrors;
                                                                    return false;
                                                                    break;
                                                                }
                                                            }
                                                            if (valid6) {
                                                                for (const key1 in data9) {
                                                                    const _errs26 = errors;
                                                                    if (typeof data9[key1] !== 'string') {
                                                                        validate52.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/mapping/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/additionalProperties/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid7 = _errs26 === errors;
                                                                    if (!valid7) {
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate52.errors = [
                                                                {
                                                                    instancePath: instancePath + '/mapping',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs20 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate52.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate52.errors = vErrors;
    return errors === 0;
}
const schema79 = {
    $id: 'urn:wisepipe-solution-domain:SolutionResultMap',
    type: 'object',
    additionalProperties: { $ref: 'urn:wisepipe-base-computation:Data' }
};
function validate54(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SolutionResultMap" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            for (const key0 in data) {
                const _errs2 = errors;
                if (!validate28(data[key0], {
                    instancePath: instancePath + '/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                    parentData: data,
                    parentDataProperty: key0,
                    rootData
                })) {
                    vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
                    errors = vErrors.length;
                }
                var valid0 = _errs2 === errors;
                if (!valid0) {
                    break;
                }
            }
        }
        else {
            validate54.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate54.errors = vErrors;
    return errors === 0;
}
const func221 = ucs2length;
const func222 = base64urlToBuffer;
const func223 = base64urlEncode;
const func224 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate51(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SolutionAndTile" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.solution === undefined && (missing0 = 'solution')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.status === undefined && (missing0 = 'status'))) {
                validate51.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.solution !== undefined) {
                    const _errs1 = errors;
                    if (!validate52(data.solution, {
                        instancePath: instancePath + '/solution',
                        parentData: data,
                        parentDataProperty: 'solution',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate52.errors : vErrors.concat(validate52.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.solutionID !== undefined) {
                        let data1 = data.solutionID;
                        const _errs2 = errors;
                        if (errors === _errs2) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 200) {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/solutionID',
                                            schemaPath: '#/properties/solutionID/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 200 },
                                            message: 'must NOT have more than 200 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/solutionID',
                                                schemaPath: '#/properties/solutionID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate51.errors = [
                                    {
                                        instancePath: instancePath + '/solutionID',
                                        schemaPath: '#/properties/solutionID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs4 = errors;
                            if (errors === _errs4) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 100) {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 100 },
                                                message: 'must NOT have more than 100 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate51.errors = [
                                                {
                                                    instancePath: instancePath + '/name',
                                                    schemaPath: '#/properties/name/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.type !== undefined) {
                                let data3 = data.type;
                                const _errs6 = errors;
                                if (errors === _errs6) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 0 || isNaN(data3)) {
                                            validate51.errors = [
                                                {
                                                    instancePath: instancePath + '/type',
                                                    schemaPath: '#/properties/type/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/type',
                                                schemaPath: '#/properties/type/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs6 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.pipeID !== undefined) {
                                    let data4 = data.pipeID;
                                    const _errs8 = errors;
                                    if (errors === _errs8) {
                                        if (typeof data4 === 'string') {
                                            const b64min0 = Math.ceil((4 * 10) / 3);
                                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func221(data4) < b64min0 || func221(data4) > b64max0) {
                                                validate51.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func221(data4) },
                                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func221(data4)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded0 = func222(data4);
                                                if (decoded0.length !== 10) {
                                                    validate51.errors = [
                                                        {
                                                            instancePath: instancePath + '/pipeID',
                                                            schemaPath: '#/properties/pipeID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 10 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded0 = func223(decoded0);
                                                    if (func224(encoded0) !== func224(data4)) {
                                                        validate51.errors = [
                                                            {
                                                                instancePath: instancePath + '/pipeID',
                                                                schemaPath: '#/properties/pipeID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate51.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs8 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.status !== undefined) {
                                        let data5 = data.status;
                                        const _errs10 = errors;
                                        if (typeof data5 !== 'string') {
                                            validate51.errors = [
                                                {
                                                    instancePath: instancePath + '/status',
                                                    schemaPath: '#/properties/status/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data5 === 'running' || data5 === 'completed' || data5 === 'failed')) {
                                            validate51.errors = [
                                                {
                                                    instancePath: instancePath + '/status',
                                                    schemaPath: '#/properties/status/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema75.properties.status.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs10 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.widgetData !== undefined) {
                                            const _errs12 = errors;
                                            if (!validate54(data.widgetData, {
                                                instancePath: instancePath + '/widgetData',
                                                parentData: data,
                                                parentDataProperty: 'widgetData',
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid0 = _errs12 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.cacheData !== undefined) {
                                                const _errs13 = errors;
                                                if (!validate54(data.cacheData, {
                                                    instancePath: instancePath + '/cacheData',
                                                    parentData: data,
                                                    parentDataProperty: 'cacheData',
                                                    rootData
                                                })) {
                                                    vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                                    errors = vErrors.length;
                                                }
                                                var valid0 = _errs13 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.mapping !== undefined) {
                                                    let data8 = data.mapping;
                                                    const _errs14 = errors;
                                                    const _errs15 = errors;
                                                    if (errors === _errs15) {
                                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                            for (const key0 in data8) {
                                                                const _errs17 = errors;
                                                                if (typeof key0 !== 'string') {
                                                                    const err0 = {
                                                                        instancePath: instancePath + '/mapping',
                                                                        schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/propertyNames/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string',
                                                                        propertyName: key0
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err0];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err0);
                                                                    }
                                                                    errors++;
                                                                }
                                                                var valid3 = _errs17 === errors;
                                                                if (!valid3) {
                                                                    const err1 = {
                                                                        instancePath: instancePath + '/mapping',
                                                                        schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/propertyNames',
                                                                        keyword: 'propertyNames',
                                                                        params: { propertyName: key0 },
                                                                        message: 'property name must be valid'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err1];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err1);
                                                                    }
                                                                    errors++;
                                                                    validate51.errors = vErrors;
                                                                    return false;
                                                                    break;
                                                                }
                                                            }
                                                            if (valid3) {
                                                                for (const key1 in data8) {
                                                                    const _errs20 = errors;
                                                                    if (typeof data8[key1] !== 'string') {
                                                                        validate51.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/mapping/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/additionalProperties/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid4 = _errs20 === errors;
                                                                    if (!valid4) {
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate51.errors = [
                                                                {
                                                                    instancePath: instancePath + '/mapping',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs14 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate51.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate51.errors = vErrors;
    return errors === 0;
}
export const solutionColumnNameMapSchemaValidation = validate58;
function validate58(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SolutionColumnNameMap" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            for (const key0 in data) {
                const _errs1 = errors;
                if (typeof key0 !== 'string') {
                    const err0 = {
                        instancePath,
                        schemaPath: '#/propertyNames/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                        propertyName: key0
                    };
                    if (vErrors === null) {
                        vErrors = [err0];
                    }
                    else {
                        vErrors.push(err0);
                    }
                    errors++;
                }
                var valid0 = _errs1 === errors;
                if (!valid0) {
                    const err1 = {
                        instancePath,
                        schemaPath: '#/propertyNames',
                        keyword: 'propertyNames',
                        params: { propertyName: key0 },
                        message: 'property name must be valid'
                    };
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                    validate58.errors = vErrors;
                    return false;
                    break;
                }
            }
            if (valid0) {
                for (const key1 in data) {
                    const _errs4 = errors;
                    if (typeof data[key1] !== 'string') {
                        validate58.errors = [
                            {
                                instancePath: instancePath + '/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                schemaPath: '#/additionalProperties/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid1 = _errs4 === errors;
                    if (!valid1) {
                        break;
                    }
                }
            }
        }
        else {
            validate58.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate58.errors = vErrors;
    return errors === 0;
}
export const solutionParamsSchemaValidation = validate59;
function validate59(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SolutionParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.type === undefined && (missing0 = 'type')) {
                validate59.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 0 || isNaN(data0)) {
                                validate59.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate59.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate59.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate59.errors = vErrors;
    return errors === 0;
}
export const solutionRecommendationSchemaValidation = validate60;
const schema83 = {
    $id: 'urn:wisepipe-solution-domain:SolutionRecommendation',
    type: 'object',
    properties: {
        recommendationID: { type: 'string', minLength: 1 },
        request: { $ref: 'urn:wisepipe-solution-domain:SolutionRequest' },
        createdAt: { type: 'string', format: 'date-time' }
    },
    required: ['recommendationID', 'request', 'createdAt']
};
function validate60(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SolutionRecommendation" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.recommendationID === undefined && (missing0 = 'recommendationID')) ||
                (data.request === undefined && (missing0 = 'request')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt'))) {
                validate60.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.recommendationID !== undefined) {
                    let data0 = data.recommendationID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate60.errors = [
                                    {
                                        instancePath: instancePath + '/recommendationID',
                                        schemaPath: '#/properties/recommendationID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate60.errors = [
                                {
                                    instancePath: instancePath + '/recommendationID',
                                    schemaPath: '#/properties/recommendationID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.request !== undefined) {
                        const _errs3 = errors;
                        if (!validate42(data.request, {
                            instancePath: instancePath + '/request',
                            parentData: data,
                            parentDataProperty: 'request',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.createdAt !== undefined) {
                            let data2 = data.createdAt;
                            const _errs4 = errors;
                            if (errors === _errs4) {
                                if (errors === _errs4) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate60.errors = [
                                                {
                                                    instancePath: instancePath + '/createdAt',
                                                    schemaPath: '#/properties/createdAt/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate60.errors = [
                                            {
                                                instancePath: instancePath + '/createdAt',
                                                schemaPath: '#/properties/createdAt/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate60.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate60.errors = vErrors;
    return errors === 0;
}
export const solutionRequestSchemaValidation = validate42;
export const solutionResultMapSchemaValidation = validate54;
export const solutionSchemaValidation = validate52;
export const solutionTileSchemaValidation = validate62;
const schema84 = {
    $id: 'urn:wisepipe-solution-domain:SolutionTile',
    type: 'object',
    properties: {
        solutionID: { type: 'string', minLength: 1, maxLength: 200 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        type: { type: 'number', minimum: 0 },
        pipeID: { type: 'string', uid: 10 },
        status: { type: 'string', enum: ['running', 'completed', 'failed'] },
        widgetData: { $ref: 'urn:wisepipe-solution-domain:SolutionResultMap' },
        cacheData: { $ref: 'urn:wisepipe-solution-domain:SolutionResultMap' },
        mapping: { $ref: 'urn:wisepipe-solution-domain:SolutionColumnNameMap' }
    },
    required: ['solutionID', 'type', 'name', 'pipeID', 'status']
};
const func230 = ucs2length;
const func231 = base64urlToBuffer;
const func232 = base64urlEncode;
const func233 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate62(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-solution-domain:SolutionTile" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.solutionID === undefined && (missing0 = 'solutionID')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.status === undefined && (missing0 = 'status'))) {
                validate62.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.solutionID !== undefined) {
                    let data0 = data.solutionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 200) {
                                validate62.errors = [
                                    {
                                        instancePath: instancePath + '/solutionID',
                                        schemaPath: '#/properties/solutionID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 200 },
                                        message: 'must NOT have more than 200 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate62.errors = [
                                        {
                                            instancePath: instancePath + '/solutionID',
                                            schemaPath: '#/properties/solutionID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate62.errors = [
                                {
                                    instancePath: instancePath + '/solutionID',
                                    schemaPath: '#/properties/solutionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate62.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate62.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.type !== undefined) {
                            let data2 = data.type;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/type',
                                                schemaPath: '#/properties/type/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate62.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.pipeID !== undefined) {
                                let data3 = data.pipeID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min0 = Math.ceil((4 * 10) / 3);
                                        const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                        if (func230(data3) < b64min0 || func230(data3) > b64max0) {
                                            validate62.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func230(data3) },
                                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func230(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded0 = func231(data3);
                                            if (decoded0.length !== 10) {
                                                validate62.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 10 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded0 = func232(decoded0);
                                                if (func233(encoded0) !== func233(data3)) {
                                                    validate62.errors = [
                                                        {
                                                            instancePath: instancePath + '/pipeID',
                                                            schemaPath: '#/properties/pipeID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.status !== undefined) {
                                    let data4 = data.status;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/status',
                                                schemaPath: '#/properties/status/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'running' || data4 === 'completed' || data4 === 'failed')) {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/status',
                                                schemaPath: '#/properties/status/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema84.properties.status.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.widgetData !== undefined) {
                                        const _errs11 = errors;
                                        if (!validate54(data.widgetData, {
                                            instancePath: instancePath + '/widgetData',
                                            parentData: data,
                                            parentDataProperty: 'widgetData',
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.cacheData !== undefined) {
                                            const _errs12 = errors;
                                            if (!validate54(data.cacheData, {
                                                instancePath: instancePath + '/cacheData',
                                                parentData: data,
                                                parentDataProperty: 'cacheData',
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid0 = _errs12 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.mapping !== undefined) {
                                                let data7 = data.mapping;
                                                const _errs13 = errors;
                                                const _errs14 = errors;
                                                if (errors === _errs14) {
                                                    if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                        for (const key0 in data7) {
                                                            const _errs16 = errors;
                                                            if (typeof key0 !== 'string') {
                                                                const err0 = {
                                                                    instancePath: instancePath + '/mapping',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/propertyNames/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string',
                                                                    propertyName: key0
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err0];
                                                                }
                                                                else {
                                                                    vErrors.push(err0);
                                                                }
                                                                errors++;
                                                            }
                                                            var valid3 = _errs16 === errors;
                                                            if (!valid3) {
                                                                const err1 = {
                                                                    instancePath: instancePath + '/mapping',
                                                                    schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/propertyNames',
                                                                    keyword: 'propertyNames',
                                                                    params: { propertyName: key0 },
                                                                    message: 'property name must be valid'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err1];
                                                                }
                                                                else {
                                                                    vErrors.push(err1);
                                                                }
                                                                errors++;
                                                                validate62.errors = vErrors;
                                                                return false;
                                                                break;
                                                            }
                                                        }
                                                        if (valid3) {
                                                            for (const key1 in data7) {
                                                                const _errs19 = errors;
                                                                if (typeof data7[key1] !== 'string') {
                                                                    validate62.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/mapping/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                            schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/additionalProperties/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid4 = _errs19 === errors;
                                                                if (!valid4) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate62.errors = [
                                                            {
                                                                instancePath: instancePath + '/mapping',
                                                                schemaPath: 'urn:wisepipe-solution-domain:SolutionColumnNameMap/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs13 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate62.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate62.errors = vErrors;
    return errors === 0;
}
export const taskInputSchemaValidation = validate65;
function validate65(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-compute-activity-domain:TaskInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.type === undefined && (missing0 = 'type')) ||
                (data.id === undefined && (missing0 = 'id')) ||
                (data.orgID === undefined && (missing0 = 'orgID'))) {
                validate65.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate65.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'spark' ||
                        data0 === 'spark-v2' ||
                        data0 === 'python' ||
                        data0 === 'python-eks' ||
                        data0 === 'stepFunction')) {
                        validate65.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema61.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.id !== undefined) {
                        let data1 = data.id;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 200) {
                                    validate65.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 200 },
                                            message: 'must NOT have more than 200 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate65.errors = [
                                            {
                                                instancePath: instancePath + '/id',
                                                schemaPath: '#/properties/id/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate65.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgID !== undefined) {
                            let data2 = data.orgID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats16.test(data2)) {
                                            validate65.errors = [
                                                {
                                                    instancePath: instancePath + '/orgID',
                                                    schemaPath: '#/properties/orgID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate65.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.orgPlan !== undefined) {
                                let data3 = data.orgPlan;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate65.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'Social' ||
                                    data3 === 'Enterprise' ||
                                    data3 === 'Integration' ||
                                    data3 === 'Temp' ||
                                    data3 === 'Starter' ||
                                    data3 === 'Professional')) {
                                    validate65.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema61.properties.orgPlan.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.highMemory !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.highMemory !== 'boolean') {
                                        validate65.errors = [
                                            {
                                                instancePath: instancePath + '/highMemory',
                                                schemaPath: '#/properties/highMemory/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.enableUsagesStream !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.enableUsagesStream !== 'boolean') {
                                            validate65.errors = [
                                                {
                                                    instancePath: instancePath + '/enableUsagesStream',
                                                    schemaPath: '#/properties/enableUsagesStream/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.logGroup !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.logGroup !== 'string') {
                                                validate65.errors = [
                                                    {
                                                        instancePath: instancePath + '/logGroup',
                                                        schemaPath: '#/properties/logGroup/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.logStreamPrefix !== undefined) {
                                                const _errs15 = errors;
                                                if (typeof data.logStreamPrefix !== 'string') {
                                                    validate65.errors = [
                                                        {
                                                            instancePath: instancePath + '/logStreamPrefix',
                                                            schemaPath: '#/properties/logStreamPrefix/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate65.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate65.errors = vErrors;
    return errors === 0;
}
export const usageInputSchemaValidation = validate66;
function validate66(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-usages-domain:UsageInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.stream === undefined && (missing0 = 'stream')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.details === undefined && (missing0 = 'details'))) {
                validate66.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.stream !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.stream !== 'string') {
                        validate66.errors = [
                            {
                                instancePath: instancePath + '/stream',
                                schemaPath: '#/properties/stream/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats16.test(data1)) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate66.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgID !== undefined) {
                            let data2 = data.orgID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats16.test(data2)) {
                                            validate66.errors = [
                                                {
                                                    instancePath: instancePath + '/orgID',
                                                    schemaPath: '#/properties/orgID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.details !== undefined) {
                                let data3 = data.details;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        var valid1 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data4 = data3[i0];
                                            const _errs9 = errors;
                                            if (errors === _errs9) {
                                                if (typeof data4 === 'string') {
                                                    if (func2(data4) < 1) {
                                                        validate66.errors = [
                                                            {
                                                                instancePath: instancePath + '/details/' + i0,
                                                                schemaPath: '#/properties/details/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate66.errors = [
                                                        {
                                                            instancePath: instancePath + '/details/' + i0,
                                                            schemaPath: '#/properties/details/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs9 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/details',
                                                schemaPath: '#/properties/details/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.orgPlan !== undefined) {
                                    let data5 = data.orgPlan;
                                    const _errs11 = errors;
                                    if (typeof data5 !== 'string') {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/orgPlan',
                                                schemaPath: '#/properties/orgPlan/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data5 === 'Social' ||
                                        data5 === 'Enterprise' ||
                                        data5 === 'Integration' ||
                                        data5 === 'Temp' ||
                                        data5 === 'Starter' ||
                                        data5 === 'Professional')) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/orgPlan',
                                                schemaPath: '#/properties/orgPlan/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema64.properties.orgPlan.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate66.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate66.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map